module.exports = {
  messages: {
    ACTION_BLOCK_USER: 'Block this user',
    ACTION_BLOCK_USER_DIALOG_DESCRIPTION:
      "Blocking {displayName} means they can't view your profile or contact you via XING.",
    ACTION_BLOCK_USER_DIALOG_TITLE: 'Really block this user?',
    ACTION_BLOCK_USER_SUCCESS: 'Member blocked',
    ARTICLE_KIT_RECOMMEND_STREAM_PLACEHOLDER: 'Add a comment about this here.',
    BUTTON_ACCEPT: 'Accept',
    BUTTON_ADD: 'Add',
    BUTTON_ADDCONTACT: 'Add as contact',
    BUTTON_BACK: 'Back',
    BUTTON_BACKTOP: 'Back to overview',
    BUTTON_CANCEL: 'Cancel',
    BUTTON_CHANGE: 'Change entries',
    BUTTON_CLEAR_FIELDS: 'Clear',
    BUTTON_CLOSEWINDOW: 'Close window',
    BUTTON_COMMENT: 'Comment',
    BUTTON_CONFIRM: 'Confirm',
    BUTTON_CONTINUE: 'OK',
    BUTTON_CORRECTNEWS: 'Make corrections to news entry',
    BUTTON_CORRECTNEWSLETTER: 'Correct newsletter',
    BUTTON_CREATE_FILE: 'Create updated file',
    BUTTON_DELCONTACT: 'Delete contact',
    BUTTON_DELETE: 'Delete',
    BUTTON_DELETE_LANGUAGE: 'Delete language',
    BUTTON_EDIT: 'Edit',
    BUTTON_FILTER: 'Filter',
    BUTTON_FORWARD: 'Next',
    BUTTON_FURTHER_INVITATIONS: 'Invite more people',
    BUTTON_GRANT_PERMISSIONS: 'Grant access rights',
    BUTTON_JOIN: 'Join',
    BUTTON_JOIN_NOW: 'Join group now',
    BUTTON_LESS: 'Less',
    BUTTON_LOAD_MORE: 'More',
    BUTTON_MORE: 'More',
    BUTTON_NEW_LANGUAGE: 'New language',
    BUTTON_NEXT_STEP: 'Next step',
    BUTTON_OK: 'OK',
    BUTTON_POST: 'Post',
    BUTTON_POST_AND_TWEET: 'Post and tweet',
    BUTTON_POST_STATUS: 'Post',
    BUTTON_PREVIEW: 'Preview',
    BUTTON_PRINT: 'Print',
    BUTTON_PUBLISH: 'Post',
    BUTTON_RELOAD_PAGE: 'Refresh page',
    BUTTON_SAVE: 'Save',
    BUTTON_SAVE_AND_CONTINUE: 'Save and continue',
    BUTTON_SAVENEWS: 'Save news entry',
    BUTTON_SEARCH: 'Search',
    BUTTON_SEND: 'Send',
    BUTTON_SENDMESSAGE: 'Send message',
    BUTTON_SENDNEWSLETTER: 'Send newsletter',
    BUTTON_SHOW: 'Show',
    BUTTON_SHOW_ERRORS: 'Display error',
    BUTTON_SHOW_LESS: 'Less',
    BUTTON_SHOW_MORE: 'Show more',
    BUTTON_SKIP_STEP: 'Skip',
    BUTTON_SUBMIT: 'Submit',
    BUTTON_SUGGEST: 'Suggest contacts',
    BUTTON_TEXT_RECOVERY: 'Retrieve text',
    BUTTON_TRY_AGAIN: 'Try again',
    BUTTON_UPDATE: 'Save changes',
    CB_POSTING_ERROR: "Sorry, that didn't work. Please try again.",
    COMMBOX_ACTOR_SWITCH_CANCEL: 'Keep role',
    COMMBOX_ACTOR_SWITCH_CONFIRM: 'Change role',
    COMMBOX_ACTOR_SWITCH_HEADLINE: 'In what role do you want to post this?',
    COMMBOX_ACTOR_SWITCH_HINT:
      'To change the author of this post, just tap on the name above.',
    COMMBOX_ACTOR_SWITCH_PROMPT_IMAGE:
      "Do you really want to change the name of the author? You'd then have to re-upload the image.",
    COMMBOX_ACTOR_SWITCH_PROMPT_VIDEO:
      "Do you really want to change the name of the author? You'd then have to re-upload the video.",
    COMMBOX_ACTOR_SWITCH_TYPE_PAGE: 'Page',
    COMMBOX_ACTOR_SWITCH_TYPE_USER: 'Member',
    COMMBOX_ADD_PHOTO_BUTTON_LABEL: 'Add photo',
    COMMBOX_ALMOST_FULL_FILLED_DROPZONE_HEADER:
      'You can add 1 more image to your post.',
    COMMBOX_AUDIENCE_CITY_CONTACTS: 'Only contacts in my city ({totalCount})',
    COMMBOX_AUDIENCE_FOLLOWERS: 'Followers only',
    COMMBOX_AUDIENCE_FOLLOWERS_AND_CONTACTS: 'Followers & contacts',
    COMMBOX_AUDIENCE_FOLLOWERS_AND_CONTACTS_DESC: 'Your post can be shared',
    COMMBOX_AUDIENCE_FOLLOWERS_DESC: 'Your post can be shared.',
    COMMBOX_AUDIENCE_HEADLINE: 'Who can see this?',
    COMMBOX_AUDIENCE_PRIVATE: 'Private (XING contacts only)',
    COMMBOX_AUDIENCE_PRIVATE_DESC: "Your post can't be shared.",
    COMMBOX_AUDIENCE_PRIVATE_SELECTED: 'Private',
    COMMBOX_AUDIENCE_PUBLIC: 'Public',
    COMMBOX_AUDIENCE_PUBLIC_DESC: 'Anyone can see and share this.',
    COMMBOX_BUTTON_ADD_VIDEO_LABEL: 'Select video',
    COMMBOX_BUTTON_OPEN_FILES_LABEL: 'Select document',
    COMMBOX_BUTTON_OPEN_POLL_LABEL: 'Create a poll',
    COMMBOX_CANCEL_POSTING_BUTTON_BACK: 'Continue editing',
    COMMBOX_CANCEL_POSTING_BUTTON_CANCEL: 'Discard post',
    COMMBOX_CANCEL_POSTING_HEADLINE: 'Discard post?',
    COMMBOX_CANCEL_POSTING_TEXT_MESSAGE:
      "You'll lose what you wrote if you discard it.",
    COMMBOX_CHARACTERS_LEFT: 'left',
    COMMBOX_EMPTY_DROPZONE_BUTTON_TEXT: 'Select images',
    COMMBOX_EMPTY_DROPZONE_TEXT: 'JPG, BMG or PNG (max. {max_size} MB each)',
    COMMBOX_EMPTY_DROPZONE_TITLE:
      'Drag & drop or select up to {max_images} images',
    COMMBOX_EMPTY_TEXT_FIELD: 'Share your thoughts, a photo or a link...',
    COMMBOX_EMPTY_TEXT_FIELD_MENTIONS:
      "Create a new post (and use '@' to mention others)…",
    COMMBOX_ENTRY_POINT_LABEL: 'Text box for your post',
    COMMBOX_ENTRY_POINT_TEXT: "What's new with you?",
    COMMBOX_FILLED_DROPZONE_HEADER:
      'You can add {pictures} more images to your post.',
    COMMBOX_FULL_FILLED_DROPZONE_HEADER:
      "You've reached the maximum number of photos you can post.",
    COMMBOX_IMAGE_BUTTON_LABEL: 'Add image',
    COMMBOX_IMAGE_SIZE_UPLOAD_ERROR:
      'Please select an image less than 10 MB in size.',
    COMMBOX_IMAGE_TYPE_UPLOAD_ERROR:
      'Please select an image in JPG or PNG format.',
    COMMBOX_POLL_VOTES_NUMBER: '{votes} votes',
    COMMBOX_POLLS_ADD_ANSWER_BUTTON: 'Add option',
    'COMMBOX_POLLS_ANSWER_HELPER_LABEL.one': '1 character left',
    'COMMBOX_POLLS_ANSWER_HELPER_LABEL.other': '{charsLeft} characters left',
    COMMBOX_POLLS_ANSWERS_PLACEHOLDER: 'Option {optionNumber}',
    COMMBOX_POLLS_ANSWERS_TITLE: 'Voting options',
    COMMBOX_POLLS_CREATE_BUTTON_LABEL: 'Create poll',
    COMMBOX_POLLS_DISCARD_DIALOG_MESSAGE:
      "You'll lose all your entries and can't undo this",
    COMMBOX_POLLS_DISCARD_DIALOG_NEGATIVE_BUTTON: 'Continue editing',
    COMMBOX_POLLS_DISCARD_DIALOG_POSITIVE_BUTTON: 'Discard',
    COMMBOX_POLLS_DISCARD_DIALOG_TITLE: 'Discard changes?',
    'COMMBOX_POLLS_DURATION_LABEL.one': '%d day',
    'COMMBOX_POLLS_DURATION_LABEL.other': '%d days',
    COMMBOX_POLLS_DURATION_TITLE: 'Poll duration',
    COMMBOX_POLLS_ICON: 'Create a poll',
    'COMMBOX_POLLS_QUESTION_HELPER_ANDROID.one': '%d character left',
    'COMMBOX_POLLS_QUESTION_HELPER_ANDROID.other': '%d characters left',
    'COMMBOX_POLLS_QUESTION_HELPER_LABEL.one': '1 character left',
    'COMMBOX_POLLS_QUESTION_HELPER_LABEL.other': '%d characters left',
    COMMBOX_POLLS_QUESTION_PLACEHOLDER:
      'e.g. Where do you like to go for lunch?',
    COMMBOX_POLLS_QUESTION_TITLE: 'Your question',
    COMMBOX_POLLS_SCREEN_TITLE: 'Create poll',
    COMMBOX_POST: 'Post',
    COMMBOX_SCHEDULE: 'Done',
    COMMBOX_SCHEDULING_DATE: 'Date',
    COMMBOX_SCHEDULING_DATE_FUTURE_ERROR: 'Please select a date in the future.',
    COMMBOX_SCHEDULING_DATE_VALIDITY_ERROR:
      'Please enter a valid date format, e.g. 20 Jan 2021.',
    COMMBOX_SCHEDULING_FENCING_CTA_BUTTON: 'Discover all benefits',
    COMMBOX_SCHEDULING_FENCING_HEADLINE: 'Schedule posts',
    COMMBOX_SCHEDULING_FENCING_SUBLINE:
      'Schedule the date and time to share your post with followers.',
    COMMBOX_SCHEDULING_HOUR_RECOS: 'Recommended times',
    COMMBOX_SCHEDULING_IMMEDIATELY: 'Now',
    COMMBOX_SCHEDULING_NOW: 'Cancel',
    COMMBOX_SCHEDULING_SAVE: 'Save',
    COMMBOX_SCHEDULING_SCHEDULE: 'Done',
    COMMBOX_SCHEDULING_TIME: 'Time',
    COMMBOX_SCHEDULING_TIME_FUTURE_ERROR: 'Please select a time in the future.',
    COMMBOX_SCHEDULING_TITLE: 'Schedule',
    COMMBOX_SUCCESS_ACTION: 'View post',
    COMMBOX_SUCCESS_DESC: 'Your post is now live on XING.\t',
    COMMBOX_SUCCESS_HEADLINE: 'Great!',
    COMMBOX_SUCCESS_SCHEDULED_DESC:
      'Your message was scheduled for {time} on {date}.',
    COMMBOX_UPDATE_BTN: 'Update',
    COMMBOX_UPLOADED_IMAGES_LIMIT_REACHED:
      "You've reached the limit of 10 images.",
    COMMBOX_VIDEO_UPLOAD_ENCODING_TITLE:
      'Your video is being prepared. This will take a moment.',
    COMMBOX_VIDEO_UPLOAD_GENERIC_ERROR:
      "Sorry, that didn't work. Please try again.",
    COMMBOX_VIEW_POST_BTN: 'View post',
    COMMENT_BUTTON_LABEL: 'Comment',
    COMPANY_BENEFIT_ACCESSIBILITY: 'Accessibility',
    COMPANY_BENEFIT_CANTEEN: 'Canteen',
    COMPANY_BENEFIT_CHILDCARE: 'Childcare',
    COMPANY_BENEFIT_COMPANY_CAR: 'Company car',
    COMPANY_BENEFIT_COMPANY_DOCTOR: 'Company doctor',
    COMPANY_BENEFIT_COMPANY_PENSION: 'Company pension',
    COMPANY_BENEFIT_CONVENIENT_TRANSPORT_LINKS: 'Convenient transport links',
    COMPANY_BENEFIT_DISCOUNTS_SPECIAL_OFFERS: 'Employee benefits',
    COMPANY_BENEFIT_DOGS_WELCOME: 'Dogs welcome',
    COMPANY_BENEFIT_EVENTS_FOR_EMPLOYEES: 'Staff events',
    COMPANY_BENEFIT_FLEXITIME: 'Flexitime',
    COMPANY_BENEFIT_HEALTH_IN_THE_WORKPLACE: 'Health in the workplace',
    COMPANY_BENEFIT_HOME_OFFICE: 'Work from home',
    COMPANY_BENEFIT_MOBILE_DEVICE: 'Mobile device',
    COMPANY_BENEFIT_PRIVATE_INTERNET_USE: 'Private internet use',
    COMPANY_BENEFIT_PROFIT_SHARING: 'Profit-sharing',
    COMPANY_BENEFIT_RESTAURANT_TICKETS: 'Restaurant tickets',
    COMPANY_BENEFIT_TRAINING: 'Training',
    CONTENT_ACTION_BLOCK_USER: 'Block this user',
    CONTENT_TIMESTAMP_AN_HOUR_AGO_LONG:
      '{minutesCount, plural,\n   =1 {Just now}\n   other {# minutes ago}\n}',
    CONTENT_TIMESTAMP_DAYS_AGO_LONG:
      '{daysCount, plural,\n    =0 {Today}\n    one {Yesterday}\n    other {# days ago}\n}',
    CONTENT_TIMESTAMP_LESS_THAN_A_MINUTE_AGO: 'Just now',
    CONTENT_TIMESTAMP_SOME_HOURS_AGO_LONG:
      '{hoursCount, plural,\n   =1 {1 hour ago}\n   other {# hours ago}\n}',
    CONTENT_TIMESTAMP_TODAY: 'Today',
    CONTENT_TIMESTAMP_YESTERDAY: 'Yesterday',
    CP_KUNUNU_RATED_BY: '{kununu_ratings_num} employer ratings on',
    CP_RECOMMENDS_ADVERTISEMENT_ABOUT_US:
      'XING recommends the following companies:',
    CROSSPOST_SHARE_ERROR:
      'Sorry, but you already shared this post in 3 other groups.',
    DAY_NAMES_SHORT: 'Mo,Tu,We,Th,Fr,Sa,Su',
    DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_CONFIRM: 'Turn off',
    DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_HEADLINE: 'Turn off mentions?',
    DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_TEXT:
      "Your name won't link to your XING profile.",
    DUPLICATE_SHARE_ERROR:
      'You already shared this so your contacts are in the loop.',
    EP_404_ERROR: 'This page appears to have gone with the wind.',
    EP_404_ERROR_SUBLINE: 'But go ahead and check out what else is on offer:',
    EP_500_ERROR: 'Looks like the server got tired of the hamster wheel.',
    EP_500_ERROR_SUBLINE: 'We’ll make sure it starts spinning again.',
    EP_503_ERROR: 'Looks like the server is playing cat and mouse with us.',
    EP_503_ERROR_SUBLINE:
      'Please bear with us while we get some cheese for them.',
    EP_ABOUT_EDIT_VIEW_LABEL_INPUT_FIELD: 'Description',
    EP_ABOUT_US_DESCRIPTION: 'About us',
    EP_ABOUT_US_DISCOVER_CTA: 'Show more',
    EP_ABOUT_US_HEADLINE: 'About us',
    EP_ABOUT_US_NAVIGATION_TITLE: 'About',
    EP_ABOUT_US_SUBPAGE_EDIT_DESCRIPTION: 'Edit title and description',
    EP_ABOUT_US_SUBPAGE_LINK: 'Discover more about us',
    EP_ADD_CONTACTS_SEARCH_LABEL: 'Add contact person',
    EP_ADD_CTA: 'Add',
    EP_ADD_IMAGE: 'Add image',
    EP_ADD_MORE_COMPANIES: 'Add company',
    EP_ADD_VIDEO: 'Add video',
    EP_ADMINISTRATE_PAGE: 'Manage page',
    EP_AFFILIATES: 'Affiliates',
    EP_AFFILIATES_CATEGORY_ASSOCIATE: 'Associate',
    EP_AFFILIATES_CATEGORY_CLIENT: 'Client',
    EP_AFFILIATES_CATEGORY_FRANCHISE: 'Franchise company',
    EP_AFFILIATES_CATEGORY_JOINT_VENTURE: 'Joint venture',
    EP_AFFILIATES_CATEGORY_PARENT: 'Parent company',
    EP_AFFILIATES_CATEGORY_PARTNER: 'Business partner',
    EP_AFFILIATES_CATEGORY_REGIONAL_BRANCH: 'Branch company',
    EP_AFFILIATES_CATEGORY_SERVICE_PROVIDER: 'Service provider',
    EP_AFFILIATES_CATEGORY_SUBSIDIARY: 'Subsidiary',
    EP_AFFILIATES_FEEDBACK_ERROR: 'Sorry, something went wrong.',
    EP_AFFILIATES_NO_DATA_DESCRIPTION:
      'Here you can add other companies in your group, along with service providers, customers, etc.',
    EP_AFFILIATES_NO_DATA_HEADER: 'Your affiliates',
    EP_AFFILIATES_UPSELL_BODY:
      'Add links to the employer profiles of your affiliates for a full brand overview.',
    EP_AFFILIATES_UPSELL_HEADLINE: 'Link partner profiles',
    EP_AFFILIATES_VALIDATION_NO_NAME_ERROR: 'Please enter a company name',
    EP_AFFILIATION_TYPE: 'Affiliation type',
    EP_ALERT_DIALOG_FOLLOW_BTN_CANCEL: 'Cancel',
    EP_ALERT_DIALOG_FOLLOW_BTN_CONFIRM: 'Follow',
    EP_ALERT_DIALOG_FOLLOW_BTN_OK: 'Okay',
    EP_ALERT_DIALOG_FOLLOW_INFORMATION_WEB:
      "Good news - you're already following {page}.",
    EP_ALERT_DIALOG_FOLLOW_QUESTION_WEB:
      'Read articles from {page} in Insights by following them.',
    EP_ALERT_DIALOG_FOLLOW_TITLE_WEB: 'Follow {page}',
    EP_ALL_CONTACTS: 'All contact persons',
    EP_AMOUNT_EMPLOYEES: 'Employees',
    EP_AND: 'and',
    EP_ARMSTRONG_CREATE: 'Create',
    EP_ARMSTRONG_CREATE_POST: 'Post',
    EP_ARTICLES_LINK_SHARE_UNSAVED_DIALOG_LEAVE_BUTTON: 'Leave',
    EP_ARTICLES_LINK_SHARE_UNSAVED_DIALOG_MESSAGE:
      'You still have unsaved changes! Do you really want to leave?',
    EP_ARTICLES_LINK_SHARE_UNSAVED_DIALOG_STAY_BUTTON: 'Stay',
    EP_ARTICLES_MODULE_DELETE_CONFIRMATION_DIALOG_CONFIRM_BUTTON: 'Delete',
    EP_ARTICLES_MODULE_DELETE_CONFIRMATION_DIALOG_DISMISS_BUTTON: 'Cancel',
    EP_ARTICLES_MODULE_DELETE_CONFIRMATION_DIALOG_MESSAGE:
      'All your work will be lost.',
    EP_ARTICLES_MODULE_DELETE_CONFIRMATION_DIALOG_TITLE: 'Delete article?',
    EP_ARTICLES_MODULE_HEADLINE: 'News',
    EP_ARTICLES_MODULE_PINNED_LABEL: 'Top article',
    EP_ARTICLES_MODULE_REPORT_BUTTON: 'Report article',
    EP_ARTICLES_NAVIGATION_TITLE: 'News',
    EP_ARTICLES_SOCIAL_COMMENTS_COUNTER_LABEL:
      '{counter, plural,\n    =1 {1 comment} \n    other {# comments}\n}',
    EP_ARTICLES_SOCIAL_SHARES_COUNTER_LABEL: '{counter} shares',
    EP_AWARDS_CARD_ARIA_LABEL: 'Award link',
    EP_AWARDS_EDIT_HINT: 'Here are the awards listed in your kununu profile.',
    EP_AWARDS_HEADLINE: 'Awards',
    EP_AWARDS_IMAGE_ALT_TEXT: 'Award',
    EP_BACK_TO_OVERVIEW: 'Back to overview',
    EP_BANNER_ROLLOUT_AUTOMATIC_ROLLOUT:
      "On 30 Nov 2020 we'll switch existing employer profiles over to a new design and migrate all of your data for you. If you prefer, you can switch now and arrange your data in the new design. Please note that you won't be able to switch back to the old design.",
    EP_BENEFIT_ACCESSIBILITY: 'Accessibility',
    EP_BENEFIT_CANTEEN: 'Canteen',
    EP_BENEFIT_CAR_PARK: 'Car park',
    EP_BENEFIT_CHILDCARE: 'Childcare',
    EP_BENEFIT_COMPANY_CAR: 'Company car',
    EP_BENEFIT_COMPANY_DOCTOR: 'Company doctor',
    EP_BENEFIT_COMPANY_PENSION: 'Company pension',
    EP_BENEFIT_CONVENIENT_TRANSPORT_LINKS: 'Convenient transport links',
    EP_BENEFIT_DISCOUNTS_SPECIAL_OFFERS: 'Discounts',
    EP_BENEFIT_DOGS_WELCOME: 'Dogs welcome',
    EP_BENEFIT_EVENTS_FOR_EMPLOYEES: 'Events for employees',
    EP_BENEFIT_FLEXITIME: 'Flexitime',
    EP_BENEFIT_HEALTH_IN_THE_WORKPLACE: 'Health in the workplace',
    EP_BENEFIT_HOME_OFFICE: 'Remote work',
    EP_BENEFIT_MOBILE_DEVICE: 'Mobile device',
    EP_BENEFIT_PRIVATE_INTERNET_USE: 'Private internet use',
    EP_BENEFIT_PROFIT_SHARING: 'Profit-sharing',
    EP_BENEFIT_RESTAURANT_TICKETS: 'Restaurant tickets',
    EP_BENEFIT_TRAINING: 'Training',
    EP_CANCEL: 'Cancel',
    EP_CHANGE_IMAGE_CTA: 'Change image',
    EP_CHANGE_TITLE_INFO:
      'Want to change your page title? Please contact <a href="mailto:customer.support@xing.com">customer.support@xing.com</a> for assistance. ',
    EP_CHANGE_TITLE_INFO_FREE:
      'Want to change your page title? Please e-mail <a href="mailto:employerprofile@xing.com">employerprofile@xing.com</a> for assistance.',
    EP_CHANGE_TITLE_INFO_FREE_V2:
      'Want to change your page title? Please e-mail <a>employerprofile@xing.com</a> for assistance.',
    EP_CHANGE_TITLE_INFO_V2:
      'Want to change your page title? Please contact <a>customer.support@xing.com</a> for assistance. ',
    EP_CHOOSE_ACTION: 'What would you like to do?',
    EP_CHOOSE_COVER: 'Select a background image',
    EP_CHOOSE_COVER_INFO_BANNER: 'How to choose the perfect cover image',
    EP_CHOOSE_COVER_INFO_BANNER_CTA: 'Learn more',
    EP_CHOOSE_LOGO:
      'Upload your company logo here so people recognise your company more easily.',
    EP_CHOOSE_SECTION: 'Crop your image:',
    EP_CLEAR_ALL: 'Reset filters',
    EP_COMMBOX_ERROR: "Sorry, that didn't work. Please try again.",
    EP_COMMBOX_PLACEHOLDER:
      'Share your thoughts, a photo or a link(…, &#8230;)',
    EP_COMMBOX_POST: 'Post',
    EP_COMMBOX_POSTING_SUCCESSFUL_MESSAGE: 'Post shared',
    EP_COMPANIES_AUTOMIGRATION_BANNER_CONTACT_SUPPORT:
      'Please contact us if you need help or if you have any questions:\n<br/>\nE-mail: <a href="mailto:customer.support@xing.com">customer.support@xing.com</a>\n<br/>\nPhone: +49 40 419 131 778',
    EP_COMPANIES_AUTOMIGRATION_BANNER_REDIRECT_ADVISE:
      'Visits to your old employer profile will be redirected to your new XING Page.',
    EP_COMPANIES_AUTOMIGRATION_BANNER_TITLE:
      "We've revamped the employer profiles!",
    EP_COMPANIES_AUTOMIGRATION_BANNER_UPDATED_URL:
      'Your employer profile link has changed to <strong>www.xing.com/pages/{slug}</strong>.',
    EP_COMPANIES_FEEDBACK_BANNER:
      'Your feedback helps us optimise the XING Employer Branding Profile for you!',
    EP_COMPANIES_FEEDBACK_BANNER_BUTTON: 'Start survey',
    EP_COMPANY_ABOUT_US_FACTS: 'Company summary',
    EP_COMPANY_ABOUT_US_INDUSTRY: 'Industry',
    EP_COMPANY_INDUSTRY: 'Industry',
    EP_COMPANY_NAME: 'Company name',
    EP_COMPANY_NAME_VALIDATION_ERROR:
      'Please enter between 2 and 64 characters.',
    EP_COMPANY_NOT_FOUND: 'Company not found',
    EP_COMPANY_PAGE_CREATION_ERROR:
      "Sorry, that didn't work. Please try again.",
    EP_COMPANY_PAGE_CREATION_INVALID_CHARACTERS_ERROR:
      'Please use letters and numbers here, without any special characters.',
    EP_COMPANY_PAGE_CREATION_NAME_ALREADY_USED_ERROR:
      "There's already a XING Page with that name. Maybe a colleague already created a XING Page for your company? Feel free to contact us if you have any questions.",
    EP_COMPANY_PAGE_CREATION_NAME_HAS_ONLY_NUMBERS_ERROR:
      'This name only seems to contains numbers. Please use letters as well.',
    EP_COMPANY_PAGE_CREATION_NAME_TOO_LONG_ERROR:
      'Sorry, this name is too long. You can use up to 80 characters.',
    EP_COMPANY_PAGE_CREATION_NAME_TOO_SHORT_ERROR:
      'Sorry, this name is too short. Please use more than two characters.',
    EP_COMPANY_PAGE_CREATION_STEP_1: 'Basic information',
    EP_COMPANY_PAGE_CREATION_STEP_2: 'Contact details',
    EP_COMPANY_PAGE_CREATION_STEP_3: 'Company logo',
    EP_COMPANY_PAGE_CREATION_STEP_4: 'Brief description',
    EP_COMPANY_RECOMMENDATIONS_HEADLINE: 'Recommended companies',
    EP_COMPANY_RECOMMENDATIONS_NAVIGATION_TITLE: 'Similar companies',
    'EP_COMPANY_SOCIAL_PROOF.one': '{username} works here.',
    'EP_COMPANY_SOCIAL_PROOF.other':
      '{numberOfContacts} of your contacts work here.',
    EP_COMPANY_SUMMARY: 'Company summary',
    EP_CONFIRMATION_LAST_STEP_CREATE_PAGE:
      "- We'll e-mail you a confirmation within 72 hours to let you know your profile has been approved.",
    EP_CONTACT_EDIT_LABEL: 'Contact label',
    EP_CONTACT_FOLLOWING: 'is following this page.',
    EP_CONTACT_WORK: 'works here.',
    EP_CONTACTS_CHANGE_OWNER_INFO:
      'To change the page owner, please e-mail <a href="mailto:{cs_email}">{cs_email}</a>',
    EP_CONTACTS_CHANGE_OWNER_INFO_V2:
      'To change the page owner, please e-mail <a>{cs_email}</a>',
    EP_CONTACTS_DESCRIPTION: 'Contact persons at',
    EP_CONTACTS_EDIT_CTA: 'Edit contact persons',
    EP_CONTACTS_EDIT_TITLE: 'Manage contact persons',
    EP_CONTACTS_EMPTY_LIST:
      "Enter the names of the people you'd like to answer queries from visitors to your XING page.",
    EP_CONTACTS_FOLLOWING: 'are following this page.',
    EP_CONTACTS_HEADLINE: 'Contact',
    EP_CONTACTS_HIGHLIGHT_INFO:
      "The first two contact persons will be displayed on your main page. All of your contact persons will be listed in the 'contact' section.",
    EP_CONTACTS_MESSENGER_INFO:
      "Please make sure the users you select are willing to act as contacts for your page. We'll notify them when your page is published.",
    EP_CONTACTS_MODULE_TITLE: 'Contact persons',
    EP_CONTACTS_NAVIGATION_TITLE: 'Contact',
    EP_CONTACTS_SEARCH_INPUT_ERROR:
      "Sorry, that didn't work. Please try again.",
    EP_CONTACTS_SEARCH_NO_RESULTS: "We didn't find anyone with that name.",
    EP_CONTACTS_SEARCH_PLACEHOLDER: 'Enter name',
    EP_CONTACTS_SUBPAGE_DESCRIPTION: 'All {pageTitle} contacts at a glance',
    EP_CONTACTS_WORK: 'work here.',
    EP_COVER_CROP_DESCRIPTION:
      '<b>Note:</b> Only the centre of the background image is visible on smaller screens (e.g. smartphones). Please use an image where your main content is within the dotted lines as this will always be visible.',
    EP_CREATE_COMPANY_PAGE_MOBILE_INFO:
      'Please use a <span>large screen</span> to create your XING Page.',
    EP_DELETE_COVER: 'Delete background image',
    EP_DELETE_COVER_DIALOG:
      'Do you really want to delete your background image? ',
    EP_DELETE_COVER_DIALOG_CONFIRM: 'Delete',
    EP_DELETE_COVER_DIALOG_HEADLINE: 'Delete background image?',
    EP_DELETE_COVER_DIALOG_KEEP: 'Cancel',
    EP_DELETE_DOCUMENT_DIALOG: 'Do you really want to delete this document?',
    EP_DELETE_DOCUMENT_DIALOG_CANCEL: 'Cancel',
    EP_DELETE_DOCUMENT_DIALOG_CONFIRM: 'Delete',
    EP_DELETE_DOCUMENT_DIALOG_HEADLINE: 'Delete document?',
    EP_DELETE_IMAGE_GM_DIALOG: 'Your image and copy will be deleted.',
    EP_DELETE_IMAGE_GM_DIALOG_CANCEL: 'Cancel',
    EP_DELETE_IMAGE_GM_DIALOG_CONFIRM: 'Yes, delete',
    EP_DELETE_IMAGE_GM_DIALOG_HEADLINE: 'Delete everything?',
    EP_DELETE_VIDEO_DIALOG_CANCEL: 'Cancel',
    EP_DELETE_VIDEO_DIALOG_CONFIRM: 'Delete',
    EP_DELETE_VIDEO_DIALOG_HEADLINE: 'Delete this video?',
    'EP_DELETE_VIDEO_DIALOG_HEADLINE (Copy)': 'Delete this video?',
    EP_DELETE_VIDEO_DIALOG_TEXT: "You won't be able to undo this.",
    EP_DIALOG_PAGE_CREATION_CLOSE: "Don't cancel",
    EP_DIALOG_PAGE_CREATION_CONFIRM: 'Close',
    EP_DISCARD_CTA: 'Discard',
    EP_DISCARD_DIALOG_CANCEL: 'Cancel',
    EP_DISCARD_DIALOG_CONFIRM: 'Discard',
    EP_DISCARD_DIALOG_HEADLINE: 'Discard changes?',
    EP_DISCARD_DIALOG_TEXT:
      "Your changes will be discarded if you don't save them.",
    EP_DISCOVER_ABOUT_US: 'Learn more',
    EP_DISCUSSION_COMMBOX_BLOCKED_BANNER:
      "You've been blocked and can’t participate in the discussion anymore. Please contact the moderation team.",
    EP_DISCUSSION_EMPTY_STATE_BODY:
      "Once someone writes a group post, you'll see it here.",
    EP_DISCUSSION_EMPTY_STATE_BODY_LO:
      "Once someone writes a group post, you'll see it here.",
    EP_DISCUSSION_EMPTY_STATE_HEADLINE: 'There are no posts yet',
    EP_DISCUSSION_EMPTY_STATE_HEADLINE_LO: 'No posts yet',
    EP_DISCUSSION_EMPTY_STATE_MODERATOR_BODY:
      'Once you publish your first post, group members will see that this group is active.',
    EP_DISCUSSION_EMPTY_STATE_MODERATOR_HEADLINE: 'Write your first group post',
    EP_DISCUSSION_HIDDEN_EMPTY_STATE_MODERATOR_BODY:
      "Hidden group posts are only visible to moderators and don't show up in the group feed. Click on the eye symbol to hide a post.",
    EP_DISCUSSION_HIDDEN_EMPTY_STATE_MODERATOR_HEADLINE:
      'No hidden group posts',
    EP_DISCUSSION_PUBLISHED_EMPTY_STATE_MODERATOR_BODY:
      'Once you publish your first post, group members will see that this group is active.',
    EP_DISCUSSION_PUBLISHED_EMPTY_STATE_MODERATOR_HEADLINE:
      'Write your first group post',
    EP_DISCUSSIONS_DELETE_POST: 'Delete this post?',
    EP_DISCUSSIONS_DELETE_POST_POPUP_BODY: "You won't be able to undo this.",
    EP_DISCUSSIONS_DELETE_POST_POPUP_CTA_CANCEL: 'Back',
    EP_DISCUSSIONS_DELETE_POST_POPUP_CTA_DELETE: 'Delete',
    EP_DISCUSSIONS_DESCRIPTION: 'Discussions',
    EP_DISCUSSIONS_EDIT_ALL: 'All posts',
    'EP_DISCUSSIONS_EDIT_ALL (Copy)': 'All posts',
    EP_DISCUSSIONS_HEADLINE: 'Discussions',
    EP_DISCUSSIONS_HIDE_POST: 'Hide post',
    EP_DISCUSSIONS_HIDE_POST_ERROR: 'Something went wrong. Please try again.',
    EP_DISCUSSIONS_HIDE_POST_POPUP_BODY:
      "It won't be visible in the group anymore.",
    EP_DISCUSSIONS_HIDE_POST_POPUP_CTA_CANCEL: 'Cancel',
    EP_DISCUSSIONS_HIDE_POST_POPUP_CTA_HIDE: 'Hide',
    EP_DISCUSSIONS_HIDE_POST_POPUP_CTA_UNHIDE: 'Unhide',
    EP_DISCUSSIONS_HIDE_POST_POPUP_HEADLINE: 'Hide this post?',
    EP_DISCUSSIONS_MARK_POST: 'Pin this post',
    EP_DISCUSSIONS_NAVIGATION_TITLE: 'Discussions',
    EP_DISCUSSIONS_REPORT_POST: 'Report this post',
    EP_DISCUSSIONS_UNHIDE_POST: 'Unhide',
    EP_DISCUSSIONS_UNHIDE_POST_POPUP_BODY:
      'Doing so will make it visible in group discussions again.',
    EP_DISCUSSIONS_UNHIDE_POST_POPUP_CTA_CANCEL: 'Cancel',
    EP_DISCUSSIONS_UNHIDE_POST_POPUP_CTA_HIDE: 'Unhide',
    EP_DISCUSSIONS_UNHIDE_POST_POPUP_HEADLINE: 'Unhide this post?',
    EP_DOCUMENT_TITLE_EDIT_ERROR: 'Please give your document a title.',
    EP_DOCUMENT_TITLE_EDIT_HINT: "Add your document's title here.",
    EP_DOCUMENT_TITLE_EDIT_LABEL: 'Document title',
    EP_DOCUMENTS_HEADLINE: 'Documents',
    EP_DONE_CTA: 'Done',
    EP_DRAFT_LAST_STEP_CREATE_PAGE:
      "– Please note that your employer profile is still in draft mode, meaning that it won't be published until we approve it.",
    EP_DRAFT_REPUBLISH_CTA: 'Post',
    EP_DRAFT_REPUBLISH_DESCRIPTION:
      'The complaint about this page has been rejected so it can be published again.',
    EP_DUMMY_COMMBOX_PLACEHOLDER: 'Create a new post…',
    EP_EDIT_ABOUT_DATA_TITLE: 'Edit details',
    EP_EDIT_ABOUTMETA_CTA: 'Edit details',
    EP_EDIT_ABOUTUS_COPY_TO_INTRO:
      'Use the first few lines from the detailed description as your brief description',
    EP_EDIT_ABOUTUS_DESCRIPTION: 'About us description',
    EP_EDIT_ABOUTUS_DESCRIPTION_DISCARD: 'Cancel',
    EP_EDIT_ABOUTUS_DESCRIPTION_PUBLISH: 'Save',
    EP_EDIT_ABOUTUS_DETAILED_REQUIRED:
      "Please add a description to the 'about us' section.",
    EP_EDIT_ABOUTUS_EXTERNALVIDEO_INFO:
      'Video links will be discontinued soon. Instead, you can upload your videos to XING directly, including subtitles and previews.',
    EP_EDIT_ABOUTUS_HINT:
      "<b>Tip:</b> Present your most important products and/or services here. To make your page easier to find (SEO), use keywords in your brief description that your target audience is likely to use.\nYou can enter both a short and a detailed description, or just the latter, in which case we'll use the first few sentences of your detailed as your short description.",
    EP_EDIT_ABOUTUS_INDUSTRIES_INTRO:
      "What's your company's industry? Add up to 5 industries here so people can find your page more easily and so we can suggest it to the right members.",
    EP_EDIT_ABOUTUS_INTRO_DESCRIPTION: 'Brief description',
    EP_EDIT_ABOUTUS_INTRO_DESCRIPTION_LABEL: 'Brief description',
    EP_EDIT_ABOUTUS_INTRO_INFO_TEXT:
      "This brief description appears in the 'About us' section of the overview page, and is also used by search engines.",
    EP_EDIT_ABOUTUS_INTRO_TITLE: 'Title',
    EP_EDIT_ABOUTUS_INTRO_TITLE_LABEL: 'Title',
    EP_EDIT_ABOUTUS_NAV_DESCRIPTION: 'Detailed description',
    EP_EDIT_ABOUTUS_NAV_FACTS: 'Company summary',
    EP_EDIT_ABOUTUS_NAV_INDUSTRIES: 'Industries',
    EP_EDIT_ABOUTUS_NAV_INTRO: 'Brief description',
    EP_EDIT_ABOUTUS_SUMMARY: 'About us summary',
    EP_EDIT_ACTION_CONTENT_PERMISSIONS: 'Permissions',
    EP_EDIT_ACTION_DISCARD: 'Cancel',
    EP_EDIT_ACTION_POST: 'Post',
    EP_EDIT_ACTION_PROMOTE: 'Promote page',
    EP_EDIT_ACTION_PUBLISH: 'Done',
    EP_EDIT_ACTION_SET_EDIT_MODE_OFF: 'See visitor view',
    EP_EDIT_ACTION_SET_EDIT_MODE_ON: 'Edit page',
    EP_EDIT_ACTION_WRITE_ARTICLE: 'Write article',
    EP_EDIT_AFFILIATES: 'Edit affiliates',
    EP_EDIT_AFFILIATES_CONFIRM_DIALOG_BODY:
      'Are you sure you want to delete the affiliate {companyName}?',
    EP_EDIT_AFFILIATES_CONFIRM_DIALOG_BODY_MARKUP:
      'Are you sure you want to delete the affiliate <strong>{companyName}</strong>?',
    EP_EDIT_AFFILIATES_CONFIRM_DIALOG_CANCEL: 'Cancel',
    EP_EDIT_AFFILIATES_CONFIRM_DIALOG_CONFIRM: 'Yes, delete',
    EP_EDIT_AFFILIATES_DESCRIPTION:
      "Here you can add subsidiaries, customers, service providers, etc. They'll need a XING employer profile of their own, and you should get their permission before adding them.",
    EP_EDIT_AFFILIATES_INFO:
      'You can offer even more information by adding subsidiaries, customers, service providers, etc. They need to have their own XING Page, and you should obtain their consent before adding them.',
    EP_EDIT_BACK_GALLERY: 'Back to gallery',
    EP_EDIT_COMPANY_FACTS_TITLE: 'Company summary',
    EP_EDIT_COMPANYSIZEID: 'Employees',
    EP_EDIT_COMPANYSIZEID_FIELD_LABEL: 'Employees',
    EP_EDIT_CONTACTS: 'Edit contact',
    EP_EDIT_CONTACTS_DELETE: 'Really remove this contact from your page?',
    EP_EDIT_CONTACTS_DELETE_CANCEL_CONFIRM: 'Remove',
    EP_EDIT_CONTACTS_DELETE_CANCEL_CTA: 'Cancel',
    EP_EDIT_CONTACTS_DELETED: 'Contact person removed',
    EP_EDIT_CONTACTS_DESCRIPTION_INPUT_FIELD:
      'Tip: Use this space to specify the topics this person can be contacted about.',
    EP_EDIT_CONTACTS_FREE_INFO:
      'Here you can add a contact person for your page who can respond to queries. To change the contact person listed here, simply add someone else and the previous contact person will be removed as you can only have one contact person.',
    EP_EDIT_CONTACTS_NAV_CONTACTS: 'Contact person',
    EP_EDIT_CONTACTS_NAV_LOCATION: 'Location',
    EP_EDIT_CONTACTS_PAID_INFO:
      "Here you can add a contact person for your page who can respond to queries. The first two contact persons will be displayed in the overview as well as under 'contact persons'.",
    EP_EDIT_DOCUMENTS: 'Edit documents',
    EP_EDIT_EVENT_ALL_LINK: 'All events',
    EP_EDIT_EVENT_COPY_EVENT: 'Copy event',
    EP_EDIT_EVENT_DRAFT_MESSAGE_BODY:
      "Once it's ready and live, you can invite everyone and promote your group.",
    EP_EDIT_EVENT_DRAFT_MESSAGE_CTA: 'Continue editing',
    EP_EDIT_EVENT_DRAFT_MESSAGE_HEADLINE:
      'Time to tell your group about your next event!',
    EP_EDIT_EVENT_EDIT_EVENTS: 'Manage events',
    EP_EDIT_EVENT_EMPTY_STATE_BODY:
      'With events focussed around a specific topic, lively discussions, shared experiences or a new way to connect with people.',
    EP_EDIT_EVENT_EMPTY_STATE_CTA: 'Organise a group event',
    EP_EDIT_EVENT_EMPTY_STATE_FAQ_LINK:
      'Need help? Here are some tips for your group event.',
    EP_EDIT_EVENT_EMPTY_STATE_HEADLINE:
      'Foster your group and attract new members - online or offline',
    EP_EDIT_EVENT_ORGANISE_CTA: 'Create new event',
    EP_EDIT_EVENT_PAST_EMPTY_STATE_BODY:
      'Regular meetings help you engage your group members, keep them in the loop and attract new ones.',
    EP_EDIT_EVENT_PAST_EMPTY_STATE_CTA: 'Copy event',
    EP_EDIT_EVENT_PAST_EMPTY_STATE_HEADLINE:
      'Time to organise your next group event!',
    EP_EDIT_EVENT_PAST_EMPTY_STATE_TIP:
      'Tip: Save time by copying your last event.',
    'EP_EDIT_EVENT_PAST_TITLE.one': 'Past event',
    'EP_EDIT_EVENT_PAST_TITLE.other': 'Past events',
    'EP_EDIT_EVENT_PAST_TITLE.zero': 'Past events',
    EP_EDIT_EVENT_SUBPAGE_BACK_LINK: 'Back to overview',
    EP_EDIT_EVENT_SUBPAGE_COPY_EVENT_BUTTON: 'Copy event',
    EP_EDIT_EVENT_SUBPAGE_DRAFT_MESSAGE_BODY:
      'The sooner you post your event, the longer people have an opportunity to see and add it to their calendar.',
    'EP_EDIT_EVENT_SUBPAGE_DRAFT_MESSAGE_HEADLINE.one':
      "Reminder: You've got a draft event waiting to be published",
    'EP_EDIT_EVENT_SUBPAGE_DRAFT_MESSAGE_HEADLINE.other':
      "Reminder: You've got draft events waiting to be published",
    'EP_EDIT_EVENT_SUBPAGE_DRAFT_MESSAGE_HEADLINE.zero':
      'Tell your group about your next event!',
    EP_EDIT_EVENT_SUBPAGE_DRAFT_TAB: 'Drafts',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_4_HELP_BODY:
      'Here are some <a>tips for your next group event</a>.',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_4_TITLE_HELP: 'Need some help?',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BODY:
      'Bring your group together by organising an event where members can meet up and network to foster a feeling of community.',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_1_BODY:
      "First, pick a date for your event and set whether it'll be online or offline. If you're holding it offline, add the venue.",
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_1_TITLE: '1. Basic information',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_2_BODY:
      'Next, you should add more details about your event - will there be presentations and networking opportunities? How can people register online and what do they need if attending in person?',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_2_TITLE: '2. Fine-tuning',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_3_BODY:
      'Once your event page is ready, start inviting people from your group along with contacts from your network or industry. Thanks to viral effects, this will generate more buzz among other XING members.',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_3_TITLE: '3. Guests',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_HEADLINE:
      'How to create an event:',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_CTA: 'Organise a group event',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_FAQ_LINK:
      'Need help? Here are some tips for your event.',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_HEADLINE:
      'Organise your next group event',
    EP_EDIT_EVENT_SUBPAGE_LIVE_TAB: 'Live',
    EP_EDIT_EVENT_SUBPAGE_MORE_BUTTON: 'More',
    EP_EDIT_EVENT_SUBPAGE_PAST_EMPTY_STATE_BODY:
      'Regular meetings help you engage your group members, keep them in the loop and attract new ones.',
    EP_EDIT_EVENT_SUBPAGE_PAST_EMPTY_STATE_HEADLINE:
      'Time to organise your next group event!',
    EP_EDIT_EVENT_SUBPAGE_PAST_EMPTY_STATE_TIP:
      'Tip: Save time by cloning your last group event.',
    EP_EDIT_EVENT_SUBPAGE_PAST_TAB: 'Archived',
    'EP_EDIT_EVENT_UPCOMING_TITLE.one': 'Upcoming event',
    'EP_EDIT_EVENT_UPCOMING_TITLE.other': 'Upcoming events',
    'EP_EDIT_EVENT_UPCOMING_TITLE.zero': 'Upcoming events',
    EP_EDIT_FOUNDINGYEAR: 'Established in',
    EP_EDIT_FOUNDINGYEAR_FIELD_LABEL: 'Year of establishment',
    EP_EDIT_GALLERY: 'Edit gallery',
    EP_EDIT_GALLERY_EMPTY_STATE_BODY:
      'Make your page interesting and unique: with pictures and videos.',
    EP_EDIT_GALLERY_EMPTY_STATE_CTA_IMAGE: 'Add image',
    EP_EDIT_GALLERY_EMPTY_STATE_CTA_VIDEO: 'Add video',
    EP_EDIT_GALLERY_EMPTY_STATE_HEADER:
      'Looking good: Your very own XING Page.',
    EP_EDIT_GROUP_RULES: 'Edit group rules',
    EP_EDIT_IMPRINT: 'Legal notice',
    EP_EDIT_IMPRINT_FIELD_LABEL: 'Legal notice',
    EP_EDIT_INDUSTRY: 'Industry',
    EP_EDIT_INDUSTRY_FIELD_LABEL: 'Industry',
    EP_EDIT_INDUSTRYSEGMENT: 'Segment',
    EP_EDIT_INDUSTRYSEGMENT_FIELD_LABEL: 'Segment',
    EP_EDIT_INFO_EDIT_VIEW: 'Edit mode active',
    EP_EDIT_INFO_MOBILE:
      'Please use a <span>large screen</span> to edit this page.\t',
    EP_EDIT_INFO_MOBILE_EDITABLE:
      "Unfortunately not all elements can be edited on small-screen. But we're on it.",
    EP_EDIT_INFO_VISITOR_VIEW: 'Visitor view active',
    EP_EDIT_LOCATION_ADDRESS: 'Street and number',
    EP_EDIT_LOCATION_ADDRESSSUFFIX: 'Address suffix',
    EP_EDIT_LOCATION_CITY: 'City',
    EP_EDIT_LOCATION_COUNTRY: 'Country',
    EP_EDIT_LOCATION_EMAIL: 'E-mail',
    EP_EDIT_LOCATION_FAXNUMBER: 'Fax',
    EP_EDIT_LOCATION_FAXNUMBERCOUNTRYCODE: 'Country code',
    EP_EDIT_LOCATION_LABEL: 'Location',
    EP_EDIT_LOCATION_PHONENUMBER: 'Phone',
    EP_EDIT_LOCATION_PHONENUMBERCOUNTRYCODE: 'Country code',
    EP_EDIT_LOCATION_POSTCODE: 'Postcode',
    EP_EDIT_LOCATION_WEBSITEURL: 'Website',
    EP_EDIT_PAGEINFO_COMPANY_BANNER:
      'Want to change the page title? Please get in touch with us directly.',
    EP_EDIT_SECTION: 'Edit crop',
    EP_EDIT_SELECTION: 'Edit entries',
    EP_EDIT_SUBPAGE_LINK: 'Edit subpage',
    EP_EDIT_WEBSITEURL: 'Website',
    EP_EDIT_WEBSITEURL_FIELD_LABEL: 'Website',
    EP_EDITBAR_MANAGE_UPDATES: 'Manage updates',
    EP_EDITOR_BODY_PLACEHOLDER: 'Add a description of your company.',
    EP_EDITOR_TITLE_PLACEHOLDER: "Enter a title, e.g. 'Who we are'.",
    EP_EMPLOYEE: 'employee',
    EP_EMPLOYEE_CARD_SHARED_CONTACTS: '{sharedContactsNumber} shared contacts',
    'EP_EMPLOYEE_CARD_SHARED_CONTACTS_WEB.one': '{value} shared contact',
    'EP_EMPLOYEE_CARD_SHARED_CONTACTS_WEB.other': '{value} shared contacts',
    'EP_EMPLOYEE_CARD_SHARED_CONTACTS_WEB.zero': 'No shared contacts',
    EP_EMPLOYEE_FENCED:
      'Log in to see all {total} employees on XING and your connections to the company.',
    EP_EMPLOYEES: 'employees',
    EP_EMPLOYEES_BUTTON_ADD_CONTACT: 'Add',
    EP_EMPLOYEES_BUTTON_REGISTER_NOW: 'Register now',
    EP_EMPLOYEES_BUTTON_SEND_MESSAGE: 'Message',
    EP_EMPLOYEES_BUTTON_SIGN_IN: 'Log in',
    EP_EMPLOYEES_COUNT: '{employeesNumber} employees',
    EP_EMPLOYEES_DESCRIPTION: 'Employees',
    EP_EMPLOYEES_EDIT_HINT:
      'Here are all the XING members who set your company as their employer.',
    EP_EMPLOYEES_EMPTY_STATE:
      'No member has yet indicated this company as employer.',
    EP_EMPLOYEES_FEEDBACK_ERROR: 'Sorry, something went wrong.',
    EP_EMPLOYEES_HEADLINE: 'Employees',
    EP_EMPLOYEES_LINK: 'See all {number} employees on XING',
    EP_EMPLOYEES_LOAD_MORE_CTA: 'More employees',
    EP_EMPLOYEES_NAVIGATION_TITLE: 'Employees',
    EP_EMPLOYEES_NUMBER_EMPTY_STATE: 'Employees',
    EP_EMPLOYEES_OR: 'or',
    EP_EMPLOYEES_SIGNIN: 'Log in',
    EP_EMPLOYEES_SUBPAGE_DESCRIPTION:
      'All XING members working at {pageTitle} at a glance',
    EP_EMPLOYEES_TEXT_CTA_REGISTER_TO_SEE:
      'Discover all {employeesNumber} employees on XING.',
    EP_EMPLOYEES_TEXT_PROFILE_IMAGE_ALT: "{profileName}'s profile photo",
    EP_EMPLOYEES_VIEW_PROFILE: 'View profile',
    EP_ERROR: 'It looks like we’re having a few problems here.',
    EP_ERROR_BODY: 'Please reload to try again.',
    EP_ERROR_HEADER: 'It looks like we’re having a few problems here.',
    EP_ERROR_RELOAD_CTA: 'Reload',
    EP_EVENT_ALL_CTA: 'All events',
    EP_EVENT_ALL_LINK: 'All events',
    EP_EVENT_DELETE_ERROR: 'Sorry, something went wrong. Please try again.',
    EP_EVENT_EMPTY_STATE_BODY:
      'Members will be notified about upcoming group events.',
    EP_EVENT_EMPTY_STATE_HEADLINE:
      "This group hasn't organised any events yet.",
    EP_EVENT_PAST_TITLE: 'Past event',
    EP_EVENT_SUBPAGE_BACK_LINK: 'Back to overview',
    EP_EVENT_SUBPAGE_EMPTY_STATE_PAST:
      "This group hasn't organised any events yet.",
    EP_EVENT_SUBPAGE_EMPTY_STATE_PAST_BODY:
      "Once the next group event's coming up, members will be notified about it.",
    EP_EVENT_SUBPAGE_EMPTY_STATE_UPCOMING:
      'There are no upcoming events for this group.',
    EP_EVENT_SUBPAGE_EMPTY_STATE_UPCOMING_BODY:
      "Once the next group event's coming up, members will be notified about it.",
    EP_EVENT_SUBPAGE_MORE_CTA: 'More',
    EP_EVENT_SUBPAGE_PAST_TAB: 'Past events',
    EP_EVENT_SUBPAGE_UPCOMING_TAB: 'Upcoming events',
    'EP_EVENT_UPCOMING_TITLE.one': 'upcoming event',
    'EP_EVENT_UPCOMING_TITLE.other': 'upcoming events',
    'EP_EVENT_UPCOMING_TITLE.zero': 'upcoming events',
    EP_EVENTS_DESCRIPTION: 'Events',
    EP_EVENTS_HEADLINE: 'Events',
    EP_EVENTS_NAVIGATION_TITLE: 'Events',
    EP_EXISTING_COMPANY_NAME:
      'This name is already in use on XING. Please use a different one.',
    EP_FAX: 'Fax',
    EP_FEEDBACK_BUTTON: 'Feedback?',
    EP_FIELD_EMPTY_OR_MIN_CHARACTERS_ERROR:
      'Please leave it empty or enter at least {value} characters here.',
    EP_FIELD_MAX_CHARACTERS_ERROR:
      'You can enter up to to {value} characters here.',
    EP_FIELD_REQUIRED_ERROR: 'Please check this entry again.',
    EP_FILE_SIZE_FORMAT_ERROR: 'Please select a PDF file up to 100 MB in size.',
    EP_FIND_US_HERE: 'Where to find us:',
    EP_FLAG_EMPLOYER_BRANDING_PROFILE: 'Employer Branding Profile',
    EP_FOLLOW: 'Follow',
    'EP_FOLLOWERS_COUNT_WEB.one': '{value} follower',
    'EP_FOLLOWERS_COUNT_WEB.other': '{value} followers',
    'EP_FOLLOWERS_COUNT_WEB.zero': 'No followers',
    'EP_FOLLOWERS_SOCIAL_PROOF.one': '{username} is following this page.',
    'EP_FOLLOWERS_SOCIAL_PROOF.other':
      '{numberOfContacts} of your contacts are following this page.',
    'EP_FOLLOWERS.one': 'follower',
    'EP_FOLLOWERS.other': 'followers',
    'EP_FOLLOWERS.zero': 'followers',
    EP_FOLLOWING: 'Following',
    EP_FORMATTEDTIMESTAMP_DAYSAGO: '{number} days ago',
    EP_FORMATTEDTIMESTAMP_DAYSAGO_SHORT: '{number} days',
    EP_FORMATTEDTIMESTAMP_TODAY: 'Today',
    EP_FORMATTEDTIMESTAMP_YESTERDAY: 'Yesterday',
    EP_FOUNDING_YEAR: 'Founded in {foundingYear}',
    EP_FOUNDING_YEAR_EMPTY_STATE: 'Year of establishment',
    EP_FREE_ADD_CONTACT_INFO:
      "You can only enter one contact person for your page, so we've added your previous contact person again.",
    EP_FREE_CONTACTS_PROBLEM:
      "Unfortunately, you can't change the contact person at the moment. Please bear with us - we're working on it.",
    EP_GALLERY_MANAGER_INFO:
      "Here you can move, edit and delete images and videos. The first four will be displayed in the 'media' module of your XING page.",
    EP_GENERAL_ERROR_BUTTON: 'Try again',
    EP_GENERAL_ERROR_TEXT: 'Please try again.',
    EP_GENERAL_ERROR_TITLE: 'It looks like we’re having a few problems here.',
    EP_GENERAL_FEEDBACK_ERROR: "Sorry, that didn't work. Please try again.",
    EP_GENERIC_FEEDBACK_ERROR:
      'Looks like the server got tired of the hamster wheel. Please try again.',
    EP_GM_IMAGE_CAPTION_HINT: 'Add a caption here',
    EP_GM_IMAGE_CAPTION_LABEL: 'Caption',
    EP_GM_IMAGE_INFO_BANNER: 'How to choose the right images',
    EP_GM_IMAGE_INFO_BANNER_CTA: 'Learn more',
    EP_GM_IMAGE_WILL_BE_DELETED: 'Image deleted',
    EP_GM_NO_MEDIA:
      'Start creating your gallery by uploading images and videos about your company.',
    EP_GM_NO_MEDIA_HEADLINE: 'Showcase your company here.',
    EP_GM_VIDEO_ENCODING: 'Encoding your <span>{video_name}</span> video...',
    EP_GM_VIDEO_ENCODING_FAILED_INFO:
      "Your video couldn't be played and will be removed. Please use a video in .avi .mov or .mp4 format with a ratio of 16:9 format and a maximum size of 5 GB. ",
    EP_GM_VIDEO_ENCODING_FAILED_TITLE:
      "Your  <span>{video_name}</span> video couldn't be encoded.",
    EP_GM_VIDEO_ENCODING_MESSAGE:
      "We'll e-mail you once it's ready and public.",
    EP_GM_VIDEO_WILL_BE_DELETED: 'Video deleted',
    EP_GO_HOME: 'Go to homepage',
    EP_GROUP_ABOUT_LEGAL_NOTICE: 'Legal notice',
    EP_GROUP_ABOUT_US_BOX_CATEGORIES_TITLE: 'Topic',
    EP_GROUP_ABOUT_US_BOX_HEADLINE: 'Info',
    EP_GROUP_ABOUT_US_CATEGORY: 'Topic',
    'EP_GROUP_ABOUT_US_EVENTS.one': '{amount} event',
    'EP_GROUP_ABOUT_US_EVENTS.other': '{amount} events',
    'EP_GROUP_ABOUT_US_EVENTS.zero': 'No events',
    EP_GROUP_ABOUT_US_FACTS: 'Info',
    'EP_GROUP_ABOUT_US_MEMBERS.one': '{amount} member',
    'EP_GROUP_ABOUT_US_MEMBERS.other': '{amount} members',
    'EP_GROUP_ABOUT_US_MEMBERS.zero': 'No members',
    EP_GROUP_ABOUT_US_RULES_EMPTY_STATE_BODY:
      "Let group members know what's okay and what's not.",
    EP_GROUP_ABOUT_US_RULES_EMPTY_STATE_CTA: 'Add group rules',
    EP_GROUP_ABOUT_US_RULES_EMPTY_STATE_EDIT: 'Edit group rules',
    EP_GROUP_ABOUT_US_RULES_EMPTY_STATE_HEADER: 'Group rules',
    EP_GROUP_ABOUT_US_RULES_EMPTY_STATE_HELP_TEXT:
      'Share your group rules, such as:\n<ul>\n<li>What kind of posts are fine and what will be considered spam</li>\n<li>General etiquette and respectful interaction</li>\n</ul>\nMake sure your rules are easy to read, e.g. by using simple language and applying formatting such as bullet points.',
    EP_GROUP_ABOUT_US_RULES_PLACEHOLDER:
      "Here you can let group members know what's okay and what's not.",
    EP_GROUP_ABOUT_US_TITLE: 'About us',
    EP_GROUP_ABOUT_US_UPCOMING_EVENTS_NONE: 'No upcoming events',
    'EP_GROUP_ABOUT_US_UPCOMING_EVENTS_WEB.one': '{amount} upcoming event',
    'EP_GROUP_ABOUT_US_UPCOMING_EVENTS_WEB.other': '{amount} upcoming events',
    'EP_GROUP_ABOUT_US_UPCOMING_EVENTS_WEB.zero': 'No upcoming events',
    'EP_GROUP_ABOUT_US_UPCOMING_EVENTS.one': '%,d upcoming event',
    'EP_GROUP_ABOUT_US_UPCOMING_EVENTS.other': '%,d upcoming events',
    'EP_GROUP_ABOUT_US_UPCOMING_EVENTS.zero': 'No upcoming events',
    EP_GROUP_ABOUT_US_VISIBILITY_PRIVATE: 'Private',
    EP_GROUP_ABOUT_US_VISIBILITY_PUBLIC: 'Public',
    EP_GROUP_CREATION_CANCEL_CTA: 'Discard group',
    EP_GROUP_CREATION_CANCEL_KEEP_CTA: 'No, keep it',
    EP_GROUP_CREATION_CANCEL_TEXT: "You'll lose all your changes on this page.",
    EP_GROUP_CREATION_CANCEL_TITLE:
      'Are you sure you want to discard your group?',
    EP_GROUP_CREATION_PROGRESS_BAR_TITLE_1: 'Name & settings',
    EP_GROUP_CREATION_PROGRESS_BAR_TITLE_2: 'Topic',
    EP_GROUP_CREATION_PROGRESS_BAR_TITLE_3: 'Description',
    EP_GROUP_CREATION_PROGRESS_BAR_TITLE_4: 'Logo',
    EP_GROUP_CREATION_STEP_1_CONDUCT_BULLET_1:
      'encourage people to share information and network together',
    EP_GROUP_CREATION_STEP_1_CONDUCT_BULLET_2:
      'help your group members to make new connections',
    'EP_GROUP_CREATION_STEP_1_CONDUCT_BULLET_2\n':
      'help your group members to make new connections',
    EP_GROUP_CREATION_STEP_1_CONDUCT_BULLET_3:
      'organise regular events (e.g. meet-ups, workshops or lightning talks)',
    EP_GROUP_CREATION_STEP_1_CONDUCT_LEGAL: 'Yes, I accept the {link}.',
    EP_GROUP_CREATION_STEP_1_CONDUCT_LEGAL_LINK:
      'code of conduct for moderators',
    EP_GROUP_CREATION_STEP_1_CONDUCT_TITLE_FEMALE:
      'As a group moderator you...',
    EP_GROUP_CREATION_STEP_1_CONDUCT_TITLE_MALE: 'As a group moderator you...',
    EP_GROUP_CREATION_STEP_1_CONDUCT_TITLE_OTHER: 'As a group moderator you...',
    EP_GROUP_CREATION_STEP_1_LOCATION_HELP_TEXT:
      'Enter a city if you want us to suggest your group to members who live or work there. Of course, everyone else can still join your group, too.',
    EP_GROUP_CREATION_STEP_1_LOCATION_OPTIONAL: '(optional)',
    EP_GROUP_CREATION_STEP_1_LOCATION_TITLE:
      'Choose a city for your group so people in the area will see it.',
    EP_GROUP_CREATION_STEP_1_NAME_HEADER: "What’s your group's name?",
    EP_GROUP_CREATION_STEP_1_NAME_HELP_TEXT:
      'The group name is the first thing people will see, so choose one that clearly conveys what your group is about.',
    EP_GROUP_CREATION_STEP_1_NAME_PLACEHOLDER: 'e.g. {city} Marketing',
    EP_GROUP_CREATION_STEP_1_TITLE: 'Name & settings',
    EP_GROUP_CREATION_STEP_1_VISIBILITY_HELP_TEXT:
      "If a group is public, all XING members can read posts there and see who's a group member.<br> \nIf a group is private, posts there are only available to group members.<br> \nPrivacy settings for events are separate from privacy settings for groups. This means that public groups can organise private events, and vice versa.",
    EP_GROUP_CREATION_STEP_1_VISIBILITY_PRIVATE:
      "Private (you can't change this later)",
    EP_GROUP_CREATION_STEP_1_VISIBILITY_PUBLIC: 'Public',
    EP_GROUP_CREATION_STEP_1_VISIBILITY_TITLE:
      'Do you want your group to be public or private?',
    EP_GROUP_CREATION_STEP_2_CATEGORY_HEADER:
      'Select topics that match your group.',
    EP_GROUP_CREATION_STEP_2_CATEGORY_HELPTEXT:
      'You can add up to 20 topics to help prospective members find your group and attend your events.',
    EP_GROUP_CREATION_STEP_2_CATEGORY_PLACEHODER:
      'e.g. marketing or project management',
    EP_GROUP_CREATION_STEP_3_DESCRIPTION_HEADER: "What's your group about?",
    EP_GROUP_CREATION_STEP_3_DESCRIPTION_HELP:
      "You can base your description on the answers to these questions:\n<ul>\n<li>Who might be interested in your group?</li>\n<li>What's it about?</li>\n<li>How often do you host events?</li>\n\nYou can use ({min}-{max} characters and format the text.",
    EP_GROUP_CREATION_STEP_3_DESCRIPTION_PLACEHOLDER:
      'e.g. Inspire and be inspired by meeting others in the industry and learning what works for them and where they maybe went wrong. ',
    EP_GROUP_CREATION_STEP_4_CTA_CREATE_GROUP: 'Request group approval',
    EP_GROUP_CREATION_STEP_4_UPLOAD_LOGO_CTA: 'Select file',
    EP_GROUP_CREATION_STEP_4_UPLOAD_LOGO_HINT:
      'JPG, BMP or PNG (max. 20 MB), ratio of 16:9',
    EP_GROUP_CREATION_STEP_4_UPLOAD_LOGO_TITLE:
      'Drag & drop or select a logo file.',
    EP_GROUP_CREATION_SUCCESS_BULLET_1:
      "We'll run a quick check to make sure it meets our requirements. This can take up to 48 hours. We'll e-mail you when your group is live.",
    EP_GROUP_CREATION_SUCCESS_BULLET_2:
      'In the meantime, you can go ahead and add a banner, images or a video. (Please use a desktop computer.)',
    EP_GROUP_CREATION_SUCCESS_BULLET_3:
      "Prepare a welcome post for new group members so you're ready when your group goes live.",
    EP_GROUP_CREATION_SUCCESS_CTA_BACK: 'Back to groups',
    EP_GROUP_CREATION_SUCCESS_HEADLINE:
      'You just created your new <name> group.',
    EP_GROUP_CREATION_SUCCESS_LARGE_SCREEN_CTA: 'Go to group',
    EP_GROUP_CREATION_SUCCESS_SMALL_SCREEN_CTA: 'Go to group',
    EP_GROUP_DELETION_CTA: 'Delete now',
    EP_GROUP_DELETION_ERROR:
      "Sorry, your group couldn't be deleted. Please try again.",
    EP_GROUP_DELETION_KEEP_CTA: 'Keep group',
    EP_GROUP_DELETION_SUCCESS: 'Your group has been deleted.',
    EP_GROUP_DELETION_TITLE: 'Are you sure you want to delete this group?',
    EP_GROUP_DISCUSSIONS_LOAD_COMMBOX_ERROR:
      "We're having trouble creating posts right now. Please try reloading.",
    EP_GROUP_DISCUSSIONS_LOAD_COMMBOX_ERROR_CTA: 'Reload',
    EP_GROUP_DISCUSSIONS_LOAD_MORE_ERROR:
      'We had a little trouble loading more posts. Please try again.',
    'EP_GROUP_HEADER_MEMBERS.one': 'member',
    'EP_GROUP_HEADER_MEMBERS.other': 'members',
    'EP_GROUP_HEADER_MEMBERS.zero': 'members',
    EP_GROUP_HEADER_VISIBILITY_PRIVATE: 'Private',
    EP_GROUP_HEADER_VISIBILITY_PUBLIC: 'Public',
    EP_GROUP_INFO_BLOCKED: 'Blocked',
    EP_GROUP_LEAVE_OWNER_ERROR_POP_UP:
      'To leave this group, please transfer ownership first by contacting our support team.',
    EP_GROUP_LEAVE_OWNER_ERROR_POP_UP_CLOSE_CTA: 'Not now',
    EP_GROUP_LEAVE_OWNER_ERROR_POP_UP_CONTACT_CTA: 'Contact',
    EP_GROUP_LEAVE_OWNER_ERROR_POP_UP_TITLE: "You're the owner of this group.",
    EP_GROUP_LEAVE_TRANSFER_OWNERSHIP_EMAIL_ADDRESS: 'en-support@xing.com',
    EP_GROUP_LEAVE_TRANSFER_OWNERSHIP_SUBJECT:
      "I'd like to transfer ownership of my group.",
    EP_GROUP_LOCATION_TITLE: 'Location',
    EP_GROUP_MEMBER_ADD_CONTACT: 'Add',
    EP_GROUP_MEMBER_ADD_CONTACT_ERROR:
      'Sorry, something went wrong. Please try again.',
    EP_GROUP_MEMBER_ALL_LINK: 'All group members',
    'EP_GROUP_MEMBER_CONTACT_SHARED_CONTACTS.one': '%d shared contact',
    'EP_GROUP_MEMBER_CONTACT_SHARED_CONTACTS.other': '%d shared contacts',
    'EP_GROUP_MEMBER_CONTACT_SHARED_CONTACTS.zero': '%d shared contacts',
    EP_GROUP_MEMBER_EDIT: 'Manage members',
    EP_GROUP_MEMBER_INVITE_CTA: 'Invite members',
    EP_GROUP_MEMBER_INVITE_PLACEHOLDER:
      'Hi, \n\nI\'d like to invite you to join the "{group_name}" group. Looking forward to seeing you there! \n\nBest, \n{invitor_name}',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_BLOCKED_EMPTY_BODY:
      'All members can access the group and read, write and comment on posts.',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_BLOCKED_EMPTY_TITLE: 'No one is blocked',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_BLOCKED_SINCE: 'Blocked since {date}',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_BLOCKED_SWITCHER: 'Blocked',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_EXCLUDED_EMPTY_BODY:
      'People you exclude lose their membership rights. If you remove the exclusion, they can join the group again.',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_EXCLUDED_EMPTY_TITLE:
      'No one is excluded right now',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_EXCLUDED_SINCE: 'Excluded since {date}',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_EXCLUDED_SWITCHER: 'Excluded',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_MEMBERS_SWITCHER: 'Members',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_REQUESTED_EMPTY_BODY:
      "Here you'll see who wants to join this group.",
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_REQUESTED_EMPTY_TITLE:
      'No new membership requests',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_REQUESTED_SINCE: 'Requested on {date}',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_REQUESTED_SWITCHER: 'Pending',
    EP_GROUP_MEMBER_POP_UP_BODY_LO:
      'Register for free or log in to view all {count} members.',
    EP_GROUP_MEMBER_REGISTER_LO: 'Register for free',
    EP_GROUP_MEMBER_SEARCH_EMPTY_BODY:
      'Perhaps your entry contains a typo. Give it another go or try a different term.',
    EP_GROUP_MEMBER_SEARCH_EMPTY_HEADLINE:
      "Sorry, we couldn't find anyone with that name.",
    EP_GROUP_MEMBER_SIGN_IN_LO: 'Log in',
    EP_GROUP_MEMBER_SUBPAGE_MORE_CTA: 'Show more',
    EP_GROUP_MEMBER_TITLE: 'Members',
    EP_GROUP_MEMBER_VIEW_PROFILE_LO: 'View profile',
    EP_GROUP_MEMBER_WRITE_MESSAGE: 'Send message',
    EP_GROUP_MEMBERS_ADD_AS_MODERATOR: 'Appoint as moderator',
    EP_GROUP_MEMBERS_ADD_AS_MODERATOR_SUCCESS:
      'You added {name} as a moderator.',
    EP_GROUP_MEMBERS_BLOCK_MEMBER: 'Block this member',
    EP_GROUP_MEMBERS_BLOCK_MEMBER_POP_UP:
      "{first_name} won't be able to post or comment until you unblock them.",
    EP_GROUP_MEMBERS_BLOCK_MEMBER_POP_UP_HEADLINE: 'Block {name}?',
    EP_GROUP_MEMBERS_BLOCK_MEMBER_POP_UP_YES: 'Block now',
    EP_GROUP_MEMBERS_BLOCK_MEMBER_SUCCESS: '{name} has now been blocked.',
    EP_GROUP_MEMBERS_BLOCK_MEMBERSHIP_POP_UP_CTA_CANCEL: 'Cancel',
    EP_GROUP_MEMBERS_CHANGE_ROLE_ERROR:
      'Sorry, something went wrong. Please try again.',
    EP_GROUP_MEMBERS_CHANGE_STATUS_POP_UP_CANCEL: 'Cancel',
    EP_GROUP_MEMBERS_CONFIRM_MEMBER_SUCCESS:
      '{first_name} is now a member, too.',
    EP_GROUP_MEMBERS_DECLINE_MEMBER_SUCCESS:
      "You've declined {name}'s membership request.",
    EP_GROUP_MEMBERS_GROUP_OWNER_INFO: 'Group owner since: {date}',
    EP_GROUP_MEMBERS_GROUP_PENDING_OWNER_INFO:
      'You can start inviting members once your group is activated. ',
    EP_GROUP_MEMBERS_LOAD_MORE_ERROR:
      'We had a little trouble loading more members. Please try again.',
    EP_GROUP_MEMBERS_MEMBERSHIP_ACTION_ERROR:
      'Sorry, something went wrong. Please try again.',
    EP_GROUP_MEMBERS_MEMBERSHIP_INFO: 'Member since: {date}',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS_BODY.one':
      'Do you want your group to grow? Accept the membership request and welcome your new member or decline it.',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS_BODY.other':
      'Do you want your group to grow? Accept the requests to welcome your new members or decline them.',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS_BODY.zero':
      'Do you want your group to grow? Accept the request to welcome your new member or decline it.',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS_CTA.one': 'View pending request',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS_CTA.other': 'View pending requests',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS_CTA.zero': 'View pending requests',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS.one': '{number} pending membership request',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS.other':
      '{number} pending membership requests',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS.zero':
      '{number} pending membership requests',
    EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP: 'Remove exclusion',
    EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP_BODY: 'Remove exclusion?',
    EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP_CTA_CANCEL: 'Cancel',
    EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP_CTA_YES: 'Remove exclusion',
    EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP_SUCCESS:
      '{name} can request to join the group again.',
    EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP_TEXT:
      "{name} will be able to request to join the group again as they won't get their membership back automatically.",
    EP_GROUP_MEMBERS_REMOVE_AS_MODERATOR: 'Remove moderator status',
    EP_GROUP_MEMBERS_REMOVE_AS_MODERATOR_POP_UP:
      "Do you want to remove {name}'s moderator status?",
    EP_GROUP_MEMBERS_REMOVE_AS_MODERATOR_POP_UP_CONTENT:
      '{first_name} will lose their moderator status and be a regular member again.',
    EP_GROUP_MEMBERS_REMOVE_AS_MODERATOR_POP_UP_YES: 'Yes, remove',
    EP_GROUP_MEMBERS_REMOVE_AS_MODERATOR_SUCCESS:
      '{name} is no longer a moderator.',
    EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP: 'Exclude from group',
    EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP_HEADLINE:
      'Exclude {name} from this group?',
    EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP_POP_UP:
      "{first_name} will be removed as a member and can't join again until you cancel their exclusion.",
    EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP_POP_UP_CANCEL: 'Cancel',
    EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP_POP_UP_YES: 'Exclude',
    EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP_SUCCESS:
      '{name} is now excluded from this group.',
    EP_GROUP_MEMBERS_SEARCH_BAR: 'e.g. Jane Doe',
    EP_GROUP_MEMBERS_SEARCH_BAR_MOBILE: 'e.g. Jane Smith',
    EP_GROUP_MEMBERS_SEARCH_BUTTON: 'Search members',
    'EP_GROUP_MEMBERS_TOTAL.one': 'One person',
    'EP_GROUP_MEMBERS_TOTAL.other': '{value} people',
    'EP_GROUP_MEMBERS_TOTAL.zero': 'Nobody',
    EP_GROUP_MEMBERS_UNBLOCK_MEMBER: 'Unblock',
    EP_GROUP_MEMBERS_UNBLOCK_MEMBER_POP_UP:
      '{first_name} will be able to post and comment in this group again.',
    EP_GROUP_MEMBERS_UNBLOCK_MEMBER_SUCCESS:
      '{name} is now unblocked and can post and comment again.',
    EP_GROUP_MEMBERS_UNBLOCK_MEMBERSHIP_POP_UP_CTA_CANCEL: 'Cancel',
    EP_GROUP_MEMBERS_UNBLOCK_MEMBERSHIP_POP_UP_CTA_YES: 'Unblock',
    EP_GROUP_MEMBERS_UNBLOCK_MEMBERSHIP_POP_UP_HEADLINE: 'Unblock {name}?',
    EP_GROUP_MEMBERS_UNDER_10_OWNER_BANNER_BODY:
      "There's bound to be some exciting people in your personal network who want to join your group and events.",
    EP_GROUP_MEMBERS_UNDER_10_OWNER_BANNER_CTA: 'Invite members',
    EP_GROUP_MEMBERS_UNDER_10_OWNER_BANNER_HEADLINE:
      'Who should join your group?',
    EP_GROUP_MEMBERS_UNDER_10_VISITOR_BANNER_BODY:
      'Do you know someone who might be interested or would like to meet other people to discuss this topic? Invite them to join this group.',
    EP_GROUP_MEMBERS_UNDER_10_VISITOR_BANNER_CTA: 'Invite contacts',
    EP_GROUP_MEMBERS_UNDER_10_VISITOR_BANNER_HEADLINE:
      'Who else should join this group?',
    EP_GROUP_OWNER_DRAFT_BANNER_BODY:
      "You're just a few details away from completing your group. Once it's published, you can start inviting people to join.",
    EP_GROUP_OWNER_DRAFT_BANNER_DELETE_CTA: 'Discard group',
    EP_GROUP_OWNER_DRAFT_BANNER_FINISH_CTA: 'Continue editing',
    EP_GROUP_OWNER_DRAFT_BANNER_TITLE:
      'Your group <b>"%group_name</b> is almost ready to go...',
    EP_GROUP_OWNER_YOUR_GROUPS_PENDING_INFO: 'Approval pending (since {date})',
    EP_GROUP_ROLE_INFO_MEMBER: 'Member',
    EP_GROUP_ROLE_INFO_MODERATOR: 'Moderator',
    EP_GROUP_RULES_TITLE: 'Group rules',
    'EP_GROUP_SOCIAL_PROOF.one': '{username} is already a group member.',
    'EP_GROUP_SOCIAL_PROOF.other':
      '{numberOfContacts} of your contacts are already group members.',
    EP_GROUP_START_PAGE_BODY:
      'XING groups are all about regular meet-ups and real connections.\nPeople can get together to talk about specific topics, to give presentations, or to network in a relaxed atmosphere.',
    EP_GROUP_START_PAGE_CREATE_GROUP_CTA: 'Start a group',
    EP_GROUP_START_PAGE_HEADER: 'Find your community!',
    EP_GROUP_START_PAGE_NEW_GROUPS_HEADER: 'Your groups with the new design',
    EP_GROUP_START_PAGE_NEW_GROUPS_INFO_BODY:
      'Migrating all of the groups from the old to the new design is likely to take around 4 weeks. But we wanted to give you access to the new design as each group is switched over.',
    EP_GROUP_START_PAGE_NEW_GROUPS_INFO_TITLE:
      'Why do some of my groups have the new design, while others still have the old one?',
    EP_GROUP_START_PAGE_NEW_GROUPS_MEMBER_BODY:
      "It's fresh and clear with a whole host of new event features for you. Every group will be switched over to the new design in the coming weeks.",
    EP_GROUP_START_PAGE_NEW_GROUPS_MODERATOR_BODY:
      "The new design offers two different views – one for regular members and one for moderators. This makes it easier for you to manage your groups. The new design is also smartphone and tablet friendly. <a href=“https://faq.xing.com/node/68236”>What's changed?</a>",
    EP_GROUP_START_PAGE_NEW_GROUPS_MODERATOR_BODY_ANDROID:
      'The new design offers two different views – one for moderators and one for members. <a href=“https://faq.xing.com/node/68236”>What else has changed?</a>',
    EP_GROUP_START_PAGE_NEW_GROUPS_MODERATOR_BODY_IOS:
      'The new design offers two different views – one for moderators and one for members. <a href=“https://faq.xing.com/node/68236”>What else has changed?</a>',
    EP_GROUP_START_PAGE_OLD_GROUPS_HEADER:
      'Your groups with the current design',
    EP_GROUP_START_PAGE_OLD_GROUPS_MEMBER_BODY:
      "These groups still use the existing design, but they'll switch over to the new one soon.",
    EP_GROUP_START_PAGE_SEARCH_GROUP_CTA: 'Search groups',
    EP_GROUP_START_PAGE_TAB_EMPTY_STATE_BODY:
      'Join your first group now and meet new people.',
    EP_GROUP_START_PAGE_TAB_EMPTY_STATE_CTA: 'Find a group',
    EP_GROUP_START_PAGE_TAB_EMPTY_STATE_TITLE: 'Here are your groups',
    EP_GROUP_XBM_ENTRY_BODY:
      'Do you want to see how your group has grown over time or how often it was found?',
    EP_GROUP_XBM_ENTRY_CTA: 'Go to group analysis',
    EP_HEADER_IMAGE_BANNER_BODY:
      'You can save your cover image <strong>as a draft</strong> right now and it will only be visible to you. <br />\nTo post your cover image, please <strong>upgrade</strong> to an Employer Branding Profile first.',
    EP_HEADER_IMAGE_BANNER_DRAFT_BUTTON: 'Save cover image as draft',
    EP_HEADER_IMAGE_BANNER_HEADER: 'Upgrade and post your cover image',
    EP_HEADER_IMAGE_BANNER_PUBLISH_BUTTON: 'Upgrade now',
    EP_HEADER_LAST_STEP_CREATE_PAGE:
      'Excellent! Your {companyName} profile is almost ready to go.',
    EP_HELP_CENTER: 'Help',
    EP_IDEAL_EMPLOYER_ADD: 'Add as ideal employer',
    EP_IDEAL_EMPLOYER_ADD_CONFIDENTIALLY:
      'Add this company as an ideal employer to indicate your interest confidentially.',
    EP_IDEAL_EMPLOYER_ADDED: 'Added as ideal employer',
    EP_IDEAL_EMPLOYER_ADMIN_ADAPT: 'To do that, head over to the BrandManager.',
    EP_IDEAL_EMPLOYER_ADMIN_GO_BM: 'Go to BrandManager',
    EP_IDEAL_EMPLOYER_ADMIN_LAPTOP:
      'To do that, head over to the BrandManager (ideally using a large screen). ',
    EP_IDEAL_EMPLOYER_ADMIN_POSITION: 'Edit ideal employer module',
    EP_IDEAL_EMPLOYER_CONFIDENTIAL_INFO:
      'Only the employer will know about this unless you choose otherwise in your job preferences.',
    EP_IDEAL_EMPLOYER_EDIT_HINT:
      'The BrandManager shows you which XING members set your company as an ideal employer.',
    EP_IDEAL_EMPLOYER_EDIT_HINT_CTA: 'Visit BrandManager',
    EP_IDEAL_EMPLOYER_EI_CONFIDENTIAL:
      'Only the employer will know about this unless you choose otherwise in your job preferences.',
    EP_IDEAL_EMPLOYER_EI_HOW: 'How does it work?',
    EP_IDEAL_EMPLOYER_EI_NON_COMMITTAL:
      "We'll let the company know you'd like to work there. ",
    EP_IDEAL_EMPLOYER_EI_POTENTIAL:
      'The company is then more likely to get in touch with you.',
    EP_IDEAL_EMPLOYER_EI_UPTO_30: 'You can add up to 30 ideal employers.',
    EP_IDEAL_EMPLOYER_HEADLINE: 'Ideal employer',
    EP_IDEAL_EMPLOYER_MAX: "You've already added 30 ideal employers.",
    EP_IDEAL_EMPLOYER_NAVIGATION_TITLE: 'Ideal employer',
    EP_IDEAL_EMPLOYER_REMOVE: 'Remove as ideal employer',
    EP_IDEAL_EMPLOYER_WORK: 'Would you like to work here?',
    EP_IMAGE_UPLOAD_SIZE_FORMAT_ERROR:
      'Please select an image in JPG, JPEG or PNG format and up to 5 MB in size.',
    EP_INDUSTRY_SUBCATEGORY: 'Segment',
    EP_INFO_LAST_STEP_CREATE_PAGE:
      '– You can continue adding content to your employer profile in the meantime. ',
    EP_INPUT_CHARS_LEFT: '{charactersNumber} characters left',
    EP_INSIDER_CHANGE_PROFILE_INFO_BUTTON: 'Visit profile',
    EP_INSIDER_CHANGE_PROFILE_INFO_TEXT:
      'You can edit your profile photo and background image in your profile.',
    EP_INVALID_COMPANY_NAME:
      'There already is a XING Page with that name. Maybe a colleague of yours created it?',
    EP_JOB_ADS_FOUND: '{total} job ads found',
    EP_JOB_JOBBOX: 'View saved jobs',
    EP_JOB_LOOKING: 'Looking for a job?',
    EP_JOB_NO_VACANCIES: 'No vacancies currently available.',
    EP_JOBS_CAREER_LEVEL: 'Career level',
    EP_JOBS_DAYSAGO: '{number} days ago',
    EP_JOBS_DESCRIPTION: 'Jobs',
    EP_JOBS_DISCIPLINE: 'Discipline',
    EP_JOBS_EDIT_HINT: "Here are all the job ads you've posted on XING.",
    EP_JOBS_EDITSWITCH_CTA: 'Go to XING JobManager',
    EP_JOBS_EDITSWITCH_DISCRIPTION:
      'You can browse and manage your vacancies in the {jobManager}.\nWe recommend using a large screen to optimise your experience.',
    EP_JOBS_EDITSWITCH_DISCRIPTION_INNER: 'XING JobManager',
    EP_JOBS_EDITSWITCH_HEADLINE: 'Post and manage job ads',
    EP_JOBS_EMPTYSTATE_BODY:
      'Hire the right people by adding a new job opening.',
    EP_JOBS_EMPTYSTATE_CTA: 'Add new vacancy',
    EP_JOBS_EMPTYSTATE_HEADER: "You don't have any vacancies right now.",
    EP_JOBS_FEEDBACK_ERROR: 'Sorry, something went wrong.',
    EP_JOBS_FILTER_ALL: 'All',
    EP_JOBS_HEADLINE: 'Jobs',
    EP_JOBS_LINK: 'All jobs',
    EP_JOBS_LOCATIONS: 'Locations',
    EP_JOBS_MATCH: '{number}% match',
    EP_JOBS_NAVIGATION_TITLE: 'Jobs',
    EP_JOBS_PUBLIC_EMPTYSTATE_BODY:
      'Looking for a job? Check out our recommendations.',
    EP_JOBS_PUBLIC_EMPTYSTATE_CTA: 'View recommendations',
    EP_JOBS_PUBLIC_EMPTYSTATE_HEADER:
      "There aren't any vacancies available right now.",
    EP_JOBS_RECOMMENDATION: 'View job recommendations',
    EP_JOBS_SEARCH_PLACEHOLDER: 'Enter a job title or keyword',
    EP_JOBS_SUBPAGE_DESCRIPTION: 'All job offers from {pageTitle} at a glance',
    EP_JOBS_TODAY: 'Today',
    EP_JOBS_YESTERDAY: 'Yesterday',
    EP_JOIN_GROUP_CTA: 'Join',
    EP_KUNUNU_ALL_BENEFITS: 'View all benefits on kununu',
    EP_KUNUNU_ALL_REVIEWS: 'All {number} reviews on kununu',
    EP_KUNUNU_BENEFITS_CONFIRMATION:
      'Confirmed by {total} out of {totalReviews} reviews',
    EP_KUNUNU_BENEFITS_TITLE: 'Employee benefits',
    EP_KUNUNU_CULTURE_BUTTON: 'View the corporate culture',
    EP_KUNUNU_DISCOVER_REVIEWS:
      'Get to know the company and see how employees rate the culture there',
    EP_KUNUNU_DISCOVER_REVIEWS_CULTURE:
      'Get to know the company and see how employees rate the culture.',
    EP_KUNUNU_EDIT_HINT: 'These ratings are from your kununu profile.',
    EP_KUNUNU_EDIT_HINT_CTA: 'View kununu profile',
    EP_KUNUNU_HEADLINE: 'Employee reviews',
    EP_KUNUNU_NAVIGATION_TITLE: 'Employer reviews & culture',
    EP_KUNUNU_RATE_COMPANY: 'Is this your current or previous employer?',
    EP_KUNUNU_RATE_COMPANY_BUTTON: 'Rate this company',
    EP_KUNUNU_RATING: 'kununu rating',
    EP_KUNUNU_RATING_VALUE: '{value} / {fullValue}',
    EP_KUNUNU_READ_REVIEW: 'Read review',
    EP_KUNUNU_RECOMMENDATION: 'recommend this employer',
    EP_KUNUNU_REVIEW_TITLE: 'What employees say',
    EP_KUNUNU_REVIEWER_CURRENT_JOB: 'Current job',
    EP_KUNUNU_REVIEWER_FORMER_JOB: 'Past job',
    EP_KUNUNU_REVIEWER_INTERNSHIP_JOB: 'Internship\t',
    EP_KUNUNU_REVIEWER_NS_JOB: 'Not specified',
    EP_KUNUNU_SHARE_BUTTON: 'Rate this employer',
    EP_KUNUNU_SHARE_DETAIL:
      'Share your experience anonymously and help us all make better work-life decisions.',
    EP_KUNUNU_SHARE_TITLE: 'Have you worked at {company}?',
    EP_KUNUNU_WHAT_SAY_BUTTON: 'View kununu profile',
    EP_LEARN_MORE_ABOUT_US: 'Learn more',
    EP_LEGAL_NOTICE: 'Legal notice',
    EP_LEGAL_NOTICE_EMPTY_STATE: 'Legal notice',
    EP_LOAD_MORE_CTA: 'Show more ',
    EP_LOCATION_ADDRESS_ERROR: 'Please check your address again.',
    EP_LOCATION_CITY_ERROR: 'Please check your city again.',
    EP_LOCATION_EMAIL_ERROR: 'Please check your e-mail address again.',
    EP_LOCATION_EMPTY_STATE_BUTTON: 'Add contact details',
    EP_LOCATION_EMPTY_STATE_TEXT:
      'Please add your address and contact details before publishing.',
    EP_LOCATION_EMPTY_STATE_TITLE: 'Address and contact details',
    EP_LOCATION_FAXNUMBER_ERROR: 'Please only enter numbers (min. 5).',
    EP_LOCATION_LABEL_ERROR: 'Please check this entry again.',
    EP_LOCATION_PHONENUMBER_ERROR: 'Please only enter numbers (min. 5).',
    EP_LOCATION_POSTCODE_ERROR: "Please don't enter any special characters.",
    EP_LOCATION_WEBSITE_ERROR: 'Please check your web address again.',
    EP_LOCATIONS_EDIT_TITLE: 'Edit location',
    EP_LOCATIONS_HEADLINE: 'Location',
    EP_LOCATIONS_NAVIGATION_TITLE: 'Location',
    EP_LOCATIONS_OPEN_MAP: 'Open map',
    EP_MAIL_LAST_STEP_CREATE_PAGE: "– We'll send your confirmation to {mail}",
    EP_MANAGE_CONTENT: 'Manage media',
    EP_MAX: 'Max.',
    EP_MEDIA_HEADLINE: 'Media',
    EP_MEMBERS_BLOCKED_MEMBER_LEAVE_BODY:
      "You'll no longer be a member and can't join again.",
    EP_MEMBERS_BLOCKED_MEMBER_LEAVE_HEADLINE: 'Leave this group?',
    'EP_MEMBERS_CARD_SHARED_CONTACTS_WEB.one': '{value} shared contact',
    'EP_MEMBERS_CARD_SHARED_CONTACTS_WEB.other': '{value} shared contacts',
    'EP_MEMBERS_CARD_SHARED_CONTACTS_WEB.zero': 'No shared contacts',
    EP_MEMBERS_DESCRIPTION: 'Members',
    EP_MEMBERS_FEEDBACK_ERROR: 'Sorry, something went wrong. Please try again.',
    EP_MEMBERS_HEADLINE: 'Members',
    EP_MEMBERS_LEAVE_GROUP_NO: 'Cancel',
    EP_MEMBERS_LEAVE_GROUP_YES: 'Leave group',
    EP_MEMBERS_MEMBER_LEAVE_BODY:
      "You'll no longer be a member but can join again.",
    EP_MEMBERS_MEMBER_LEAVE_HEADLINE: 'Leave this group?',
    EP_MEMBERS_MODERATOR_LEAVE_BODY:
      "You'll no longer be a member. If you join again, you won't be a moderator.",
    EP_MEMBERS_MODERATOR_LEAVE_HEADLINE: 'Leave this group?',
    EP_MEMBERS_NAVIGATION_TITLE: 'Members',
    EP_MEMBERS_OR: 'or',
    EP_META_ABOUT_US_DESCRIPTION:
      "► Find out what it's like to work at {pageTitle} and what makes the company stand out as an employer.",
    EP_META_ABOUT_US_TITLE: 'About {pageTitle} | XING',
    EP_META_COMPANY_DESCRIPTION:
      '► Alles über {pageTitle} als Arbeitgeber: Informationen, Neuigkeiten, offene Stellen, Ansprechpersonen, Standorte und mehr',
    EP_META_CONTACTS_DESCRIPTION:
      "Who to contact if you'd like to know more about {pageTitle} as an employer",
    EP_META_CONTACTS_TITLE: 'HR contacts for {pageTitle} | XING',
    EP_META_DESCRIPTION_COMPANY_PAGES:
      'Discover what {pageTitle} has to offer as an employer.',
    EP_META_DESCRIPTION_DEFAULT:
      'Discover general information, job vacancies and updates for {pageTitle} on XING.',
    EP_META_DESCRIPTION_PUBLISHER_PAGES:
      "Here you'll find every article and post by {pageTitle} on XING.",
    EP_META_DESCRIPTION_TOPIC_PAGES:
      "Here you'll find every news feed about {pageTitle} on XING.",
    EP_META_DISCUSSIONS_DESCRIPTION:
      '✅ Latest topics and discussions in the {pageTitle} group.',
    EP_META_DISCUSSIONS_TITLE: '{pageTitle} discussions | XING',
    EP_META_EMPLOYEES_DESCRIPTION:
      '► Mitarbeiter·innen von {pageTitle} bei XING. Wenn kennst Du schon – und seid Ihr schon vernetzt? Wenn nicht, lernt Euch kennen und tauscht Euch zu gemeinsamen Themen aus.',
    EP_META_EMPLOYEES_TITLE: 'Employees of {pageTitle} | XING',
    EP_META_EVENTS_DESCRIPTION:
      "✅ Here you'll find {pageTitle}'s events. Network and discuss what matters to you with like-minded people or learn something new.",
    EP_META_EVENTS_TITLE: 'All events by {pageTitle} | XING',
    EP_META_JOBS_DESCRIPTION:
      "✅ Looking for a job? Here you'll find {pageTitle}'s current vacancies. See what the company has to offer and apply for a vacancy.",
    EP_META_JOBS_TITLE: 'Available jobs at {pageTitle} | XING',
    EP_META_MEMBERS_DESCRIPTION:
      "✅ See who's already a member and connect with them.",
    EP_META_MEMBERS_TITLE: '{pageTitle} members | XING',
    EP_META_NEWS_DESCRIPTION:
      "► Visit {pageTitle}'s page on XING for news and information.",
    EP_META_NEWS_TITLE: 'News from {pageTitle} | XING',
    EP_META_PAGE_TITLE: '{pageTitle}: Information and Updates | XING',
    EP_META_WEBSITE_ERROR:
      "Sorry, but that doesn't appear to be a website. Maybe there's a typo?",
    EP_META_YEAR_LABEL_ERROR:
      "Sorry, but that doesn't appear to be a year. Maybe there's a typo?",
    EP_MIN: 'Min.',
    EP_MODULE_DISCUSSION_EDITOR_TAB_HIDDEN: 'Hidden',
    EP_MODULE_DISCUSSION_EDITOR_TAB_PUBLISHED: 'Posted',
    EP_MODULE_DISCUSSION_SHOW_MORE: 'Show more',
    EP_MODULE_DISCUSSION_TITLE: 'Discussions',
    EP_MODULE_DISCUSSIONS_ALL_LINK: 'Show all posts',
    EP_MODULE_ERROR_SUBLINE:
      'Please try reloading or returning to the {overview}.',
    EP_MODULE_ERROR_SUBLINE_INNER: '{entityPage} overview',
    EP_NA: 'N/A',
    EP_NAVIGATION_ARIA_LABEL: 'Page components navigation',
    EP_NAVIGATION_EDIT_HINT:
      'Add and remove tabs and change their order in the BrandManager.',
    EP_NAVIGATION_EDIT_HINT_CTA: 'Visit BrandManager',
    EP_NEW_PAGE_CREATED_DRAFT:
      'This employer profile is in draft mode, i.e. unpublished.',
    EP_NEWS_ACTION_TYPE_ARTICLE: 'shared this article:',
    EP_NEWS_ACTION_TYPE_IMAGE: 'shared this image.',
    EP_NEWS_ACTION_TYPE_LINK: 'shared this link.',
    EP_NEWS_ACTION_TYPE_TEXT: 'posted the following',
    EP_NEWS_ACTION_TYPE_VIDEO: 'shared this video.',
    EP_NEWS_DESCRIPTION: 'News',
    EP_NEWS_HEADLINE: 'News',
    EP_NEWS_MODULE_EDIT_ALL: 'Manage news',
    EP_NEWS_NAVIGATION_TITLE: 'News',
    EP_NEWS_SHOW_ALL: 'Show all news',
    EP_NEWS_SUBPAGE_DESCRIPTION: 'All news from {pageTitle} at a glance',
    EP_NEWS_UPSELL_POPOVER_BODY:
      'Pinned articles always appear at the top of your feed, making it easy for you to find them again.',
    EP_NEWS_UPSELL_POPOVER_BUTTON: 'Discover all benefits',
    EP_NEWS_UPSELL_POPOVER_HEADER: 'Pin top articles',
    EP_NEXT_BUTTON_LAST_STEP_CREATE_PAGE: 'Continue editing',
    EP_NO_DOCUMENTS:
      'Share your latest presentations, product details and annual reports with your page visitors.',
    EP_NO_DOCUMENTS_HEADLINE: 'Upload your PDF files here.',
    EP_OF_CONTACTS: 'of your contacts',
    EP_ON_XING: 'on XING',
    EP_OPTIONAL_FIELD_HINT: 'Optional',
    EP_OPTIONS: 'What would you like to do?',
    EP_PAGE_CREATION_ABOUT_US_SUBHEADER:
      "The title and description will appear in 'About Us' in your employer profile. Both are needed to request approval, but can still be changed later in your profile.",
    EP_PAGE_CREATION_BACK_TO_COMPANIES: 'Back to overview',
    EP_PAGE_CREATION_CLOSE: 'Yes, delete',
    EP_PAGE_CREATION_CLOSE_PROCESS: 'Really delete the {name} profile?',
    EP_PAGE_CREATION_COMPANY_NAME_HELPER:
      "Please make sure you enter your company name correctly as you can't change it after saving.",
    EP_PAGE_CREATION_CONDITIONS:
      'I\'m authorised to claim this XING Page and I accept the <a href="https://www.xing.com/terms/employer-branding-profil" target="_blank">Terms and Conditions for XING Company Profiles.</a>',
    EP_PAGE_CREATION_CONTACTS_INFO:
      "Your company's contact details will be listed in your employer profile.",
    EP_PAGE_CREATION_DELETE_PROFILE: 'Delete draft profile',
    EP_PAGE_CREATION_DIALOG_CLOSE: 'Cancel',
    EP_PAGE_CREATION_DIALOG_TEXT:
      "Are you sure you want to cancel this process? You'll lose all your changes on this page.",
    EP_PAGE_CREATION_DO_NOT_CLOSE: 'Continue editing',
    EP_PAGE_CREATION_FORM_1_TITLE: 'Company details',
    EP_PAGE_CREATION_RESUME_OR_DELETE:
      "Please finish creating your employer profile and send it to us for approval. Simply delete this profile if you'd like to start over again.",
    EP_PAGE_CREATION_SAVE_NEXT: 'Save and continue',
    EP_PAGE_CREATION_SEND_FOR_APPROVAL: 'Request approval',
    EP_PAGE_INFO_HELP_BODY:
      'Check out our tips to help you put together an appealing page.',
    EP_PAGE_INFO_HELP_CTA: 'Visit help section',
    EP_PAGE_INFO_HELP_TITLE: 'Questions?',
    EP_PAGE_INFO_MANAGE_BODY:
      'You can add, hide or sort modules in the BrandManager.',
    EP_PAGE_INFO_MANAGE_CTA: 'Visit BrandManager',
    EP_PAGE_INFO_MANAGE_TITLE: 'Manage modules',
    EP_PAGE_INFO_PAGE_TYPE_FREE: 'Free profile',
    EP_PAGE_INFO_PAGE_TYPE_LABEL: 'Page type',
    EP_PAGE_INFO_PAGE_TYPE_PAID: 'Employer Branding Page',
    EP_PAGE_INFO_PAGE_TYPE_PAID_PLUS: 'Employer Branding Page Professional',
    EP_PAGE_INFO_ROLE_ADMINISTRATOR: 'Admin',
    EP_PAGE_INFO_ROLE_EDITOR: 'Editor',
    EP_PAGE_INFO_ROLE_LABEL: 'Your role:',
    EP_PAGE_INFO_ROLE_OWNER: 'Page owner',
    EP_PAGE_INFO_TITLE: 'About this page',
    EP_PAGE_OWNER: 'Page owner',
    EP_PARAMS_INCORRECT_ERROR:
      'Please add a title and a description (min. 4 characters each).',
    EP_PENDING_GROUP_JOIN_INFO: 'Pending',
    EP_PROMOTE_PAGE: 'Promote page',
    EP_PUBLISH_CTA: 'Save',
    EP_READ_LESS: 'Less',
    EP_READ_MORE: 'Read more',
    EP_READ_MORE_CTA: 'Read more',
    EP_REPORT_NEWS_ITEM: 'Report',
    EP_REPORT_PAGE: 'Report this page',
    EP_REQUIRED_FIELD: 'Required field',
    EP_RESTORE_CTA: 'Restore',
    EP_RESULT_LIST_CONTACT:
      'Not found who you want to add as a contact person for your page? Please contact  <a href="mailto:customer.support@xing.com">customer.support@xing.com</a> for assistance.',
    EP_RESULT_LIST_CONTACT_V2:
      'Not found who you want to add as a contact person for your page? Please contact  <a>customer.support@xing.com</a> for assistance.',
    EP_RESULT_LIST_HEADLINE: 'Choose contact person',
    EP_ROLLOUT_BANNER_ADD_LEGAL_NOTICE: 'Your legal notice',
    EP_ROLLOUT_BANNER_CONFIRM_BUTTON: 'Switch to the new design',
    EP_ROLLOUT_BANNER_CONTACT_DETAILS: "Your company's contact details",
    EP_ROLLOUT_BANNER_CONTACT_DETAILS_DESCRIPTION:
      "Please enter your company's address and phone number here.",
    EP_ROLLOUT_BANNER_DESCRIPTION:
      'Your new employer profile is almost ready to go.\nAll you need to do is to check the following information and update or complete it:',
    EP_ROLLOUT_BANNER_LEGAL_ADVICE_DESCRIPTION:
      "Please provide a link to the legal notice on your company's website or add this information here.",
    EP_ROLLOUT_BANNER_MOBILE_INFO:
      'Please open your employer profile on the desktop before switching to the new design.',
    EP_ROLLOUT_BANNER_OLD_URL:
      'Visitors to your old employer profile will be redirected.',
    EP_ROLLOUT_BANNER_PROFILE_UPDATED: 'Welcome to your new employer profile!',
    EP_ROLLOUT_BANNER_PUBLISH_INFO:
      'All done and checked? Great, then you’re ready to switch:',
    EP_ROLLOUT_BANNER_TEXT_EMAIL:
      'Please contact us if you need help or if you have any questions:\n<br/>\nE-mail: <a href="mailto:customer.support@xing.com">customer.support@xing.com</a>\n<br/>\nPhone: +49 40 419 131 778',
    EP_ROLLOUT_BANNER_TITLE: 'Nearly done!',
    EP_ROLLOUT_BANNER_UPDATED_URL:
      'Your XING Page link has changed to <strong>www.xing.com/pages/{slug}</strong>',
    EP_ROLLOUT_BANNER_WEBINAR_LINK:
      'https://attendee.gotowebinar.com/rt/2071891534032487180',
    EP_ROLLOUT_PUBLISH_ERROR_ABOUT_US:
      "Please add a detailed description to your 'About us' section.",
    EP_ROLLOUT_PUBLISH_ERROR_LOCATION:
      "Please add your company's contact details.",
    EP_ROLLOUT_WEBINAR_TEXT_1:
      'Are you interested in a tour of your new XING Page? Or do you have any questions? No problem! Simply sign up to one of our',
    EP_ROLLOUT_WEBINAR_TEXT_2: 'Register for one of our',
    EP_ROLLOUT_WEBINAR_TEXT_LINK: 'live webinars (German only)',
    EP_SEE_ALL_AWARDS: 'Show all awards',
    EP_SELECT_NONE: 'None',
    EP_SHARE_PAGE: 'Share this page',
    EP_SHOW_ALL_RESULTS: 'Show all results',
    EP_SHOW_MORE_RESULTS: 'Show more results',
    EP_SIMILAR_JOBS_HEADLINE: 'Similar jobs',
    EP_SLOGAN_EDIT_HEADLINE: 'Edit slogan',
    EP_SLOGAN_EDIT_HEADLINE_INFO:
      'Add a slogan to let visitors know what your page is about.',
    EP_SLOGAN_EDIT_HINT: "Add your page's slogan here.",
    EP_SLOGAN_EDIT_LABEL: 'Page slogan',
    EP_SOME_JOB_ADS_FOUND: 'All matching job ads',
    EP_SUBPAGE_BACK: 'Back to overview',
    EP_TELEPHONE: 'Phone',
    EP_TITLE_EDIT_HINT: 'You can use your company name, for example.',
    EP_TITLE_EDIT_LABEL: 'Page title',
    EP_UNFOLLOW: 'Unfollow',
    EP_UPDATES_EDIT_EMPTY_STATE_DESCRIPTION:
      "Every update you post draws other XING members' attention to your page.",
    EP_UPDATES_EDIT_EMPTY_STATE_HEADLINE: 'Write your first article',
    EP_UPDATES_PUBLIC_EMPTY_STATE_DESCRIPTION:
      'Follow this page to receive future updates in your feed.',
    EP_UPDATES_PUBLIC_EMPTY_STATE_HEADLINE: 'Updates',
    EP_UPLOAD_COVER: 'Select a background image',
    EP_UPLOAD_COVER_LABEL: 'Add a stylish background image to your page.',
    EP_UPLOAD_DOCUMENT: 'Upload PDF',
    EP_UPLOAD_IMAGE_DRAG_LABEL: 'Drop your logo here.',
    EP_UPLOAD_IMAGE_HINT: 'JPG, BMP or PNG (max. 5 MB), ratio of 16:9',
    EP_UPLOAD_IMAGE_LABEL: 'Drag & drop or select a file.',
    EP_UPLOAD_LOGO: 'Add new logo',
    EP_UPLOAD_LOGO_DRAG_LABEL: 'You can drop your logo now.',
    EP_UPLOAD_LOGO_EDIT_INFO: 'How to choose the perfect logo',
    EP_UPLOAD_LOGO_EDIT_INFO_CTA: 'Learn more',
    EP_UPLOAD_LOGO_HINT: 'JPG, BMP or PNG (max. 5 MB) in square format',
    EP_UPLOAD_LOGO_LABEL: 'Drag & drop or browse your file.',
    EP_UPSELL_BANNER_CONTAINER_DISCARD_BUTTON: 'Discard',
    EP_UPSELL_BANNER_CONTAINER_PUBLISH_BUTTON: 'Continue',
    EP_UPSELL_BODY_TOP_HEADER:
      'Add your cover image and slogan to your employer profile for greater reach and better brand recognition among your target audience.\n \nShow everyone what your company stands for!',
    EP_UPSELL_COMPANY_RECOMMENDED_BODY:
      'Upgrade your profile to stop recommendations from other companies appearing on your own employer profile. This helps to keep the focus just on you. ',
    EP_UPSELL_COMPANY_RECOMMENDED_HEADER: 'Less is more!',
    EP_UPSELL_CONTACT_BODY:
      'Add multiple contact persons to your employer profile so visitors know who to approach.',
    EP_UPSELL_CONTACT_HEADER: 'Who to contact',
    EP_UPSELL_DOCUMENTS:
      'Make your employer profile the first port of call for visitors looking for information by providing official company presentations, tips, manuals and more. ',
    EP_UPSELL_DOCUMENTS_HEADER: 'Build a single place for relevant information',
    EP_UPSELL_DOCUMENTS_HEADLINE: 'Add documents',
    EP_UPSELL_EMPLOYER_FLAG_BUTTON: 'Employer Branding Profile',
    EP_UPSELL_EMPLOYER_FLAG_CONTENT_BODY:
      'This is one of the many benefits you get with an Employer Branding Profile.<br />\nSimply click on the pen icon, <strong>select an image</strong>, and <strong>move it into the right position</strong>. You can publish it with an upgrade.',
    EP_UPSELL_EMPLOYER_FLAG_CONTENT_BODY_WITH_IMAGE:
      'Only you can see your cover image right now. <br />\nUpgrade to an Employer Branding Profile so everyone gets to see it.',
    EP_UPSELL_EMPLOYER_FLAG_CONTENT_BUTTON: 'Upgrade',
    EP_UPSELL_EMPLOYER_FLAG_CONTENT_HEADER: 'Add your cover image here!',
    EP_UPSELL_EMPLOYER_FLAG_CONTENT_HEADER_WITH_IMAGE: 'Nice cover image!',
    EP_UPSELL_GALLERY_ABOUT_US:
      'Make your employer profile interesting and unique. Use your own personal design options with pictures and videos from your company, your team or your product.',
    EP_UPSELL_GALLERY_ABOUT_US_HEADER: 'Mix things up with multimedia',
    EP_UPSELL_GALLERY_BUTTON: 'Discover benefits',
    EP_UPSELL_HEADER_TOP_HEADER:
      'Attract new talent with a cover image and slogan',
    EP_UPSELL_PROFILE_MULTIMEDIA_BODY:
      'Make your employer profile interesting and unique. Use your own personal design options with pictures and videos from your company, your team or your product.',
    EP_UPSELL_PROFILE_MULTIMEDIA_HEADER: 'Mix things up with multimedia',
    EP_VISIT_WEBSITE: 'Website',
    EP_VISIT_WEBSITE_EMPTY_STATE: 'Website',
    EP_WHO_TO_CONTACT: 'Who to contact',
    EP_YOUR_TOPICS_EDIT_VIEW_CANCEL: 'Cancel',
    EP_YOUR_TOPICS_EDIT_VIEW_COPY:
      'Select or create up to 4 topics you write about as an Insider to make it easier for people to find you.',
    EP_YOUR_TOPICS_EDIT_VIEW_LABEL: 'Add topic',
    EP_YOUR_TOPICS_EDIT_VIEW_SAVE: 'Save',
    EP_YOUR_TOPICS_EDIT_VIEW_TITLE: 'Your topics',
    'EP-ARTICLES-MODULE-EMPTY-STATE-EDIT-TEXT':
      'Use the XING article editor or share a link to one of your external articles.',
    'EP-ARTICLES-MODULE-EMPTY-STATE-EDIT-TITLE': 'Write your first article',
    'EP-ARTICLES-MODULE-EMPTY-STATE-PINNED-TEXT':
      'Pin one of your articles to the top of your collection by clicking the star.',
    'EP-ARTICLES-MODULE-EMPTY-STATE-PINNED-TITLE':
      'Highlight your best article',
    'EP-ARTICLES-MODULE-EMPTY-STATE-TEXT':
      'Follow this page to receive notifications about new articles.',
    'EP-ARTICLES-MODULE-EMPTY-STATE-TITLE': 'No articles published yet',
    'EP-ARTICLES-MODULE-FILTER-ALL': 'All articles',
    'EP-ARTICLES-MODULE-FILTER-DRAFTS': 'Draft',
    'EP-ARTICLES-MODULE-FILTER-HIDDEN': 'Hidden',
    'EP-ARTICLES-MODULE-FILTER-PUBLISHED': 'Published',
    'EP-ARTICLES-MODULE-FILTER-SCHEDULED': 'Scheduled',
    'EP-ARTICLES-MODULE-MOBILE-HINT-TEXT':
      "The editor isn't available on mobile devices.",
    'EP-ARTICLES-MODULE-MOBILE-HINT-TITLE':
      'Please switch to a desktop computer',
    'EP-ARTICLES-MODULE-SHARE-NEW-ARTICLE-BUTTON': 'Share external article',
    'EP-ARTICLES-MODULE-SHOW-MORE-ARTICLES-BUTTON': 'Show more articles',
    'EP-ARTICLES-MODULE-WRITE-NEW-ARTICLE-BUTTON': 'Write new article',
    FEEDY_CARD_VERB_CONTENT_PAGE_ARTICLE_POST: 'posted this article',
    FEEDY_CARD_VERB_IMAGE_POST: 'shared this image',
    FEEDY_CARD_VERB_LINK_POST: 'shared this link',
    FEEDY_CARD_VERB_STATUS_POST: 'posted an update',
    IMAGE_UPLAD_READY_CTA: 'Browse files',
    INDUSTRY: 'Industry',
    INDUSTRY_10000: 'Architecture and planning',
    INDUSTRY_100000: 'Telecommunications',
    INDUSTRY_10100: 'Civil engineering',
    INDUSTRY_10200: 'Construction',
    INDUSTRY_10300: 'Building materials',
    INDUSTRY_10400: 'Architecture',
    INDUSTRY_10500: 'Gardening and landscaping',
    INDUSTRY_110000: 'Media and publishing',
    INDUSTRY_110100: 'Information services',
    INDUSTRY_110200: 'Broadcast media',
    INDUSTRY_110300: 'Publishing',
    INDUSTRY_110400: 'Film and music',
    INDUSTRY_110500: 'Journalism',
    INDUSTRY_110600: 'Translation and interpreting',
    INDUSTRY_110700: 'Copywriting and proofreading',
    INDUSTRY_120000: 'Banking and financial services',
    INDUSTRY_120100: 'Financial services',
    INDUSTRY_120200: 'Banking',
    INDUSTRY_120300: 'Investment banking',
    INDUSTRY_120400: 'Venture capital and private equity',
    INDUSTRY_130000: 'Insurance',
    INDUSTRY_140000: 'Real estate',
    INDUSTRY_140100: 'Facility management',
    INDUSTRY_140200: 'Real estate management',
    INDUSTRY_140300: 'Real estate',
    INDUSTRY_150000: 'Auditing, tax and law',
    INDUSTRY_150100: 'Legal services',
    INDUSTRY_150200: 'Auditing',
    INDUSTRY_150300: 'Tax consulting',
    INDUSTRY_160000: 'Consulting',
    INDUSTRY_170000: 'Marketing, PR and design',
    INDUSTRY_170100: 'Marketing and advertising',
    INDUSTRY_170200: 'Market research and opinion polling',
    INDUSTRY_170300: 'Graphic design',
    INDUSTRY_170400: 'Trade fairs, exhibitions and conventions',
    INDUSTRY_170500: 'PR',
    INDUSTRY_180000: 'HR services',
    INDUSTRY_180100: 'HR services and consulting',
    INDUSTRY_180200: 'Outsourcing and offshoring',
    INDUSTRY_190000: 'Civil service, associations and institutions',
    INDUSTRY_190100: 'Non-profit organisations and charities',
    INDUSTRY_190200: 'Religious institutions',
    INDUSTRY_190300: 'Public administration',
    INDUSTRY_190400: 'Politics, unions and associations',
    INDUSTRY_190500: 'Defence, judiciary and police',
    INDUSTRY_190600: 'International affairs',
    INDUSTRY_20000: 'Consumer goods and trade',
    INDUSTRY_200000: 'Education and science',
    INDUSTRY_200100: 'Research',
    INDUSTRY_200200: 'Schools and childcare',
    INDUSTRY_200300: 'Academia',
    INDUSTRY_200400: 'Childcare',
    INDUSTRY_200500: 'Coaching and training',
    INDUSTRY_200600: 'E-learning',
    INDUSTRY_20100: 'Food',
    INDUSTRY_20200: 'Beverage',
    INDUSTRY_20300: 'Tobacco products',
    INDUSTRY_20400: 'Fashion and textiles',
    INDUSTRY_20500: 'Luxury goods and jewellery',
    INDUSTRY_20600: 'Furniture and wood products',
    INDUSTRY_20700: 'Stationery',
    INDUSTRY_20800: 'Cosmetics and toiletries',
    INDUSTRY_20900: 'Glass and ceramics',
    INDUSTRY_21000: 'Import and export',
    INDUSTRY_210000: 'Health and social',
    INDUSTRY_210100: 'Hospitals',
    INDUSTRY_210200: 'Veterinary',
    INDUSTRY_210300: 'Medical practices',
    INDUSTRY_210400: 'Alternative medicine',
    INDUSTRY_210500: 'Psychology and psychotherapy',
    INDUSTRY_210600: 'Medical services',
    INDUSTRY_210700: 'Nursing sector',
    INDUSTRY_210800: 'Welfare',
    INDUSTRY_21100: 'Wholesale',
    INDUSTRY_21200: 'Retail',
    INDUSTRY_220000: 'Art, culture and sport',
    INDUSTRY_220100: 'Performing arts',
    INDUSTRY_220200: 'Photography',
    INDUSTRY_220300: 'Music',
    INDUSTRY_220400: 'Arts and crafts',
    INDUSTRY_220500: 'Museums and cultural establishments',
    INDUSTRY_220600: 'Libraries',
    INDUSTRY_220700: 'Sports clubs, sports centres and gyms',
    INDUSTRY_220800: 'Athletes, organisers and associations',
    INDUSTRY_230000: 'Other industries',
    INDUSTRY_230100: 'Gambling and betting',
    INDUSTRY_230200: 'Agriculture',
    INDUSTRY_230300: 'Forestry and hunting',
    INDUSTRY_230400: 'Fishery',
    INDUSTRY_230500: 'Other services',
    INDUSTRY_230600: 'Mining and metals',
    INDUSTRY_230700: 'Geology',
    INDUSTRY_230800: 'Security and investigation',
    INDUSTRY_30000: 'Automotive and vehicle manufacturing',
    INDUSTRY_30100: 'Automotive, motorcycles and bicycles',
    INDUSTRY_30200: 'Shipbuilding',
    INDUSTRY_30300: 'Railway locomotive and rolling stock manufacturing',
    INDUSTRY_30400: 'Traffic engineering',
    INDUSTRY_30500: 'Aerospace',
    INDUSTRY_30600: 'Vehicle rental',
    INDUSTRY_40000: 'Industry and mechanical engineering',
    INDUSTRY_40100: 'Instrumentation and control engineering',
    INDUSTRY_40200: 'Semiconductors and electronic components',
    INDUSTRY_40300: 'Printing',
    INDUSTRY_40400: 'Composites',
    INDUSTRY_40500: 'Chemicals',
    INDUSTRY_40600: 'Mineral oil processing',
    INDUSTRY_40700: 'Metal and metalworking',
    INDUSTRY_40800: 'Biotechnology and nanotechnology',
    INDUSTRY_40900: 'Plastic and rubber goods',
    INDUSTRY_41000: 'Armaments',
    INDUSTRY_41100: 'Mechanical and industrial engineering',
    INDUSTRY_41200: 'Electrical engineering',
    INDUSTRY_41300: 'Optical instruments and photographic equipment',
    INDUSTRY_50000: 'Pharmaceutical and medical technology',
    INDUSTRY_50100: 'Medical technology',
    INDUSTRY_50200: 'Pharmaceutical and medicinal products',
    INDUSTRY_60000: 'Energy, water and environment',
    INDUSTRY_60100: 'Renewable energy',
    INDUSTRY_60200: 'Energy',
    INDUSTRY_60300: 'Water supply and sanitation',
    INDUSTRY_60400: 'Waste and recycling',
    INDUSTRY_60500: 'Environmental protection',
    INDUSTRY_70000: 'Transport and logistics',
    INDUSTRY_70100: 'Public transport',
    INDUSTRY_70200: 'Rail',
    INDUSTRY_70300: 'Shipping',
    INDUSTRY_70400: 'Aviation',
    INDUSTRY_70500: 'Storage',
    INDUSTRY_70600: 'Post and forwarding',
    INDUSTRY_80000: 'Tourism and food service',
    INDUSTRY_80100: 'Hotel',
    INDUSTRY_80200: 'Restaurant and food service',
    INDUSTRY_80300: 'Travel agencies',
    INDUSTRY_80400: 'Leisure facilities',
    INDUSTRY_90000: 'Internet and IT',
    INDUSTRY_90100: 'Software',
    INDUSTRY_90200: 'IT service provider',
    INDUSTRY_90300: 'IT security',
    INDUSTRY_90400: 'Computer networking',
    INDUSTRY_90500: 'Computer hardware',
    INDUSTRY_90600: 'Consumer electronics',
    INDUSTRY_90700: 'Internet and online media',
    INDUSTRY_90800: 'Computer games',
    INSIDER_DESCRIPTION_INTRO: 'Writes about',
    'JOBS_DATE_DAYS_LEFT_LABEL.one': '{variable_1} day left',
    'JOBS_DATE_DAYS_LEFT_LABEL.other': '{variable_1} days left',
    JOBS_DATE_EXPIRING_TODAY_LABEL: 'Expiring today',
    JOBS_JOB_TEASER_SAVE: 'Save job',
    JOBS_NEW_JOB_LABEL: 'New',
    JOBS_TIMESTAMP_30_PLUS_DAYS_AGO: '30+ days ago',
    JOBS_TIMESTAMP_30_PLUS_DAYS_AGO_A11Y: 'Posted more than 30 days ago',
    JOBS_TIMESTAMP_JUST_NOW: 'Just now',
    JOBS_TIMESTAMP_JUST_NOW_A11Y: 'Posted just now',
    JOBS_TIMESTAMP_N_DAYS_AGO: '{number} days ago',
    JOBS_TIMESTAMP_N_DAYS_AGO_A11Y: 'Posted {number} days ago',
    JOBS_TIMESTAMP_N_HOURS_AGO:
      '{number, plural, =1 {1 hour ago} other {# hours ago}}',
    JOBS_TIMESTAMP_N_HOURS_AGO_A11Y:
      '{number, plural, =1 {Posted 1 hour ago} other {Posted # hours ago}}',
    JOBS_TIMESTAMP_YESTERDAY: 'Yesterday',
    JOBS_TIMESTAMP_YESTERDAY_A11Y: 'Posted yesterday',
    JS_REALLY: 'Do you really want to do this?',
    JS_REALLY_DELETE: 'Really delete?',
    LIKE_BUTTON_LABEL: 'Like',
    LIKERS_LIST_HEADLINE: 'Members who like this:',
    LINKCAP_LIST: 'List',
    LOGGEDOUT_BUTTON_ADDCONTACT: 'Add {-display_name} as a contact',
    MALT_IMAGE_UPLOAD_BROWSE_BUTTON: 'Browse files',
    MESSAGESHTML_SEARCH_INBOX: 'Search by name',
    MESSENGER_SHARE_COMMENT_PLACEHOLDER: 'Comment on your link here.',
    MESSENGER_SHARE_RECEIPENT_SELECTION_FORM_LABEL: 'Recipients:',
    MESSENGER_SHARE_RECEIPENT_SELECTION_PLACEHOLDER: 'Enter recipients',
    MESSENGER_SHARE_TARGET_LABEL: 'Your message:',
    MOB_ENTITY_PAGES_JOBS_MODULE_SUBPAGE_UNLOCK: 'Unlock top jobs',
    MONTH_NAMES:
      'January,February,March,April,May,June,July,August,September,October,November,December',
    MONTH_NAMES_SHORT: 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec',
    NAVIGATION_EXPAND_NETWORK_ADDITION: 'Try it now!',
    NEWS_MODULE_DELETE_LABEL: 'Delete',
    NEWS_MODULE_DIALOG_DELETE_HEADLINE: 'Delete',
    NEWS_MODULE_DIALOG_DELETE_NO: 'No',
    NEWS_MODULE_DIALOG_DELETE_TEXT: 'Delete this article?',
    NEWS_MODULE_DIALOG_DELETE_YES: 'Yes',
    NEWS_MODULE_DIALOG_HIDE_HEADLINE: 'Hide',
    NEWS_MODULE_DIALOG_HIDE_NO: 'No',
    NEWS_MODULE_DIALOG_HIDE_TEXT:
      "XING members won't be able to find it any more.",
    NEWS_MODULE_DIALOG_HIDE_YES: 'Yes',
    NEWS_MODULE_DIALOG_PIN_HEADLINE: 'Pin as top article',
    NEWS_MODULE_DIALOG_PIN_NO: 'No',
    NEWS_MODULE_DIALOG_PIN_TEXT: 'Pin this article to the top?',
    NEWS_MODULE_DIALOG_PIN_YES: 'Yes',
    NEWS_MODULE_DIALOG_UNPIN_HEADLINE: 'Unpin',
    NEWS_MODULE_DIALOG_UNPIN_NO: 'No',
    NEWS_MODULE_DIALOG_UNPIN_TEXT: 'Unpin this article from the top?',
    NEWS_MODULE_DIALOG_UNPIN_YES: 'Yes',
    NEWS_MODULE_DRAFT_LABEL: 'Draft',
    NEWS_MODULE_DRAFT_TAB: 'Drafts',
    NEWS_MODULE_EDIT_ALL: 'Edit all news items',
    NEWS_MODULE_EDIT_LABEL: 'Edit',
    NEWS_MODULE_EMPTY_STATE_DESCRIPTION:
      'Follow this page to receive future updates in your feed.',
    NEWS_MODULE_EMPTY_STATE_TITLE: 'Updates',
    NEWS_MODULE_EMPTYSTATE_DESCRIPTION:
      'Every update you post attracts XING members to your page.',
    NEWS_MODULE_EMPTYSTATE_TITLE: 'Write your first article',
    NEWS_MODULE_HIDDEN_LABEL: 'Hidden',
    NEWS_MODULE_HIDDEN_TAB: 'Hidden',
    NEWS_MODULE_HIDE_BUTTON: 'Hide',
    NEWS_MODULE_PIN_BUTTON: 'Pin to top',
    NEWS_MODULE_PINNED_LABEL: 'Pinned',
    NEWS_MODULE_PROMOTE_BUTTON: 'Promote',
    NEWS_MODULE_PROMOTE_LABEL: 'Sponsored',
    NEWS_MODULE_PUBLISH_FIRST_ARTICLE_BODY:
      'Visitors of your entity page are only able to see this side section, if you have published at least one news article or post.',
    NEWS_MODULE_PUBLISH_FIRST_ARTICLE_TITLE: 'Publish your first article',
    NEWS_MODULE_PUBLISHED_STORY_LABEL: 'Published',
    NEWS_MODULE_PUBLISHED_TAB: 'Published',
    NEWS_MODULE_SCHEDULE_LABEL: 'Scheduled',
    NEWS_MODULE_SCHEDULED_TAB: 'Scheduled',
    NEWS_MODULE_SHOW_BUTTON: 'Show',
    NEWS_MODULE_SHOW_STATISTICS: 'View statistics',
    NEWS_MODULE_TOP_AREA_CTA: 'Select an article',
    NEWS_MODULE_TOP_AREA_HEADLINE: 'No top articles selected.',
    NEWS_MODULE_TOP_AREA_SUB:
      'Write and publish an article, then click on the star to feature it.',
    NEWS_MODULE_TOP_LABEL: 'Top article',
    NEWS_MODULE_UNPIN_BUTTON: 'Unpin',
    NEWS_MODULE_UNPIN_LABEL: 'Remove pin',
    POLLS_HEADER_LABEL: 'Poll',
    POLLS_SHOW_RESULT_TITLE: 'Show results',
    POLLS_SHOW_VOTING_OPTIONS_TITLE: 'Show voting options',
    POLLS_TIME_ENDED: 'Poll closed',
    POLLS_TIME_LAST_MINUTES: 'Last chance to vote',
    'POLLS_TIME_REMAINING_DAYS_IOS.one': 'Ends tomorrow',
    'POLLS_TIME_REMAINING_DAYS_IOS.other': 'Ends in %d days',
    'POLLS_TIME_REMAINING_DAYS_IOS.zero': 'Ends today',
    'POLLS_TIME_REMAINING_DAYS_WEB.one': 'Ends tomorrow',
    'POLLS_TIME_REMAINING_DAYS_WEB.other': 'Ends in {days} days',
    'POLLS_TIME_REMAINING_DAYS_WEB.zero': 'Ends today',
    POLLS_VOTE_ERROR: "Sorry, that didn't work. Please try again.",
    'POLLS_VOTES_NUMBER_IOS.one': '1 vote',
    'POLLS_VOTES_NUMBER_IOS.other': '%d votes',
    'POLLS_VOTES_NUMBER_IOS.zero': '0 votes',
    'POLLS_VOTES_NUMBER_WEB.one': '1 vote',
    'POLLS_VOTES_NUMBER_WEB.other': '{votes} votes',
    'POLLS_VOTES_NUMBER_WEB.zero': '0 votes',
    SHARE_ACTIONSHEET_HEADER: 'Share this post',
    SHARE_BOX_DEFAULT_ERROR_MESSAGE:
      'Sorry, something went wrong. Please try again later.',
    SHARE_BOX_HEADER: 'Share on XING',
    SHARE_BOX_PLACEHOLDER: 'Comment on your link here.',
    SHARE_BOX_SHARE_SUCCESS: 'Thanks for sharing!',
    SHARE_BOX_SUBMIT_SHARE: 'Share',
    SHARE_BUTTON_LABEL: 'Share',
    SHARE_CANCEL_BUTTON: 'Cancel',
    SHARE_CHAT_CONTACTS: 'Select a contact',
    SHARE_CHAT_HINT: 'Your recipients will each receive a message.',
    SHARE_COUNTER_LABEL:
      '{counter, plural,\n    =1 {1 share}\n    other {# shares}\n}',
    SHARE_FEEDBACK_GROUPS_BUTTON: 'View post',
    SHARE_FEEDBACK_GROUPS_MESSAGE: '{item} shared in the {group} group',
    SHARE_FEEDBACK_INSIDERARTICLE_LABEL: 'Article',
    SHARE_FEEDBACK_JOB_LABEL: 'Job',
    SHARE_FEEDBACK_KLARTEXT_LABEL: 'Post',
    SHARE_FEEDBACK_LINK_LABEL: 'Link',
    SHARE_FEEDBACK_MESSENGER_BUTTON: 'View message',
    SHARE_FEEDBACK_MESSENGER_MESSAGE: '{item} shared via XING message',
    SHARE_FEEDBACK_NEWS_LABEL: 'Article',
    SHARE_FEEDBACK_PICTURE_LABEL: 'Image',
    SHARE_FEEDBACK_POST_LABEL: 'Post',
    SHARE_FEEDBACK_STARTPAGE_BUTTON: 'View post',
    SHARE_FEEDBACK_STARTPAGE_MESSAGE: '{item} shared on the homepage',
    SHARE_FEEDBACK_VIDEO_LABEL: 'Video',
    SHARE_FETCH_ERROR:
      "We're having problems connecting right now. Please try again later.",
    SHARE_FETCH_ERROR_COUNTDOWN: 'Trying again in {countdown} seconds.',
    SHARE_FETCH_ERROR_RETRY: 'Try again',
    SHARE_MOST_RECENT_CHATS: 'Chats',
    SHARE_PREVIEW_ERROR_HEADLINE: 'Preview currently unavailable.',
    SHARE_QUICKSHARE_TO_STARTPAGE: 'In the feed',
    SHARE_TEXT_BOX_LENGTH_ERROR:
      "{delta, plural, \none {Sorry, that's 1 character too many.} \nother {Sorry, that's # characters too many.}\n}",
    SHARE_TO_GROUPS: 'In a group',
    SHARE_TO_GROUPS_AUTOCOMPLETE_FORUMS: 'Forum',
    SHARE_TO_GROUPS_AUTOCOMPLETE_GROUPS: 'Group',
    SHARE_TO_GROUPS_SELECTION_LABEL: 'Select group:',
    SHARE_TO_GROUPS_TEXT_PLACEHOLDER: 'Comment on your link here.',
    SHARE_TO_GROUPS_THREAD_LABEL: 'Your post:',
    SHARE_TO_GROUPS_TITLE_PLACEHOLDER: 'Title',
    SHARE_TO_MESSENGER: 'Via private message',
    SHARE_TO_MESSENGER_EMPTY_STATE:
      "Unfortunately there weren't any hits for {query}.",
    SHARE_TO_STARTPAGE: 'In the feed with a comment',
    SHARE_USER_SUBTEXT_GROUPS: 'Share with a group',
    SHARE_USER_SUBTEXT_MESSAGE: 'Share in a chat message',
    SHARE_USER_SUBTEXT_STARTPAGE: 'Share on XING',
    SHARED_BUTTON_CONTINUE: 'Continue',
    SHARER_LIST_HEADLINE_MEMBERS: '{total} members shared this.',
    SHARER_LIST_HEADLINE_MULTIPLE_MEMBERS: '{total} members shared this.',
    SHARER_LIST_HEADLINE_ONE_MEMBER: 'One member shared this.',
    SHARER_LIST_ITEM_GO_TO_POST_LINK: 'View post',
    SHARER_LIST_POST_NOTIFICATION:
      "Some posts aren't visible here due to users' privacy settings.",
    SHARERS_BACK_TO_POST_LINK: 'Back',
    SHARERS_LIST_BACK_LINK: 'Back',
    SOCIAL_ADD_CONTACT: 'Add as contact',
    SOCIAL_BAR_VIEW_COUNTER_DESCRIPTION:
      'Click on the eye icon to find out your visibility. ',
    SOCIAL_BAR_VIEW_COUNTER_HEADING: 'Your visibility',
    SOCIAL_BAR_VIEW_COUNTER_SEEN:
      'For instance, this post was seen <strong>{views} times</strong>.',
    SOCIAL_BAR_VIEW_COUNTER_TIP:
      'Want to increase your reach? Find out how to <a>boost your visibility on XING</a>.',
    SOCIAL_COMMENT_BUTTON_LABEL: 'Comment',
    SOCIAL_COMMENT_COUNTER_LABEL: '{amount} comments',
    SOCIAL_COMMENT_CREATE_BUTTON_LABEL: 'Comment',
    SOCIAL_COMMENT_DELETE_LABEL: 'Delete comment',
    SOCIAL_COMMENT_DELETED_MESSAGE: 'Comment deleted.',
    SOCIAL_COMMENT_EDIT_LABEL: 'Edit comment',
    SOCIAL_COMMENT_ERROR_TOO_LARGE:
      'Please limit your comment to 20,000 characters.',
    SOCIAL_COMMENT_LIST_EMPTY_HEADLINE: 'Have your say',
    SOCIAL_COMMENT_LIST_EMPTY_SUBLINE: 'Add your voice to the conversation.',
    SOCIAL_COMMENT_OVERFLOW_ERROR: '{amount} characters',
    SOCIAL_COMMENT_REPORT_LABEL: 'Report comment',
    SOCIAL_COMMENT_WAS_EDITED: 'Edited',
    SOCIAL_COMMENTS_COUNTER_LABEL:
      '{counter, plural,\n    =0 {Be the first to comment:}\n    =1 {1 comment} \n    other {# comments}\n}',
    SOCIAL_COMMENTS_CREATE_MENTION_PLACEHOLDER:
      'Comment here and use @ to mention others',
    SOCIAL_COMMENTS_CREATE_PLACEHOLDER: 'Enter your comment here...',
    SOCIAL_COMMENTS_DELETE_DIALOG_CANCEL: 'Cancel',
    SOCIAL_COMMENTS_DELETE_DIALOG_CONFIRM: 'Delete',
    SOCIAL_COMMENTS_DELETE_DIALOG_CREATOR_TEXT:
      'Not entirely happy with what you wrote? Edit or retract it if you like.',
    SOCIAL_COMMENTS_DELETE_DIALOG_HEADLINE: 'Delete this comment?',
    SOCIAL_COMMENTS_DELETE_DIALOG_TEXT: "You won't be able to undo this.",
    SOCIAL_COMMENTS_DELETE_MENTION_LABEL: 'Block mentions',
    SOCIAL_COMMENTS_DELETED_TEXT: 'Comment deleted.',
    SOCIAL_COMMENTS_ERROR: "That didn't work. Please try again.",
    SOCIAL_COMMENTS_FORM_PLACEHOLDER: 'Comment and use @ to mention',
    SOCIAL_COMMENTS_LOAD_MORE: 'Show more comments',
    SOCIAL_COMMENTS_MORE_REPLIES: 'Show more replies',
    SOCIAL_COMMENTS_PREVIOUS_COMMENTS: 'Show previous comments',
    SOCIAL_COMMENTS_PREVIOUS_REPLIES: 'Show previous replies',
    SOCIAL_COMMENTS_REPLY_PLACEHOLDER: 'Reply to {authorName}',
    SOCIAL_GENERIC_REPORT: 'Report',
    SOCIAL_INTERACTION_BAR_COMMENT_INPUT_HINT: 'Comment here...',
    SOCIAL_LIKERS_LIST_HEADLINE: 'Members who like this:',
    SOCIAL_LIKERS_LIST_POST_NOTIFICATION:
      "Some likes aren't visible here due to users' privacy settings.",
    SOCIAL_LOAD_MORE_BUTTON: 'Load more',
    SOCIAL_OK: 'OK',
    SOCIAL_PMBX_COMMENT_CONTENT_URL: 'Content',
    SOCIAL_PMBX_COMMENT_DATE: 'Date',
    SOCIAL_PMBX_COMMENT_HEADING: 'Your comments and replies',
    SOCIAL_PMBX_COMMENT_MESSAGE: 'Your comment',
    SOCIAL_PMBX_COMMENT_ORIGIN: 'Where did you comment?',
    SOCIAL_PMBX_COMMENT_TITLE: 'Your comments and replies',
    SOCIAL_PMBX_COMMENT_USER_AGENT: 'User agent',
    SOCIAL_PMBX_DESCRIPTION:
      'Posts on XING you liked, shared, mentioned someone or commented on',
    SOCIAL_PMBX_MENTION_DOCUMENT_URL: 'Contents',
    SOCIAL_PMBX_MENTION_HEADING: 'Your mentions',
    SOCIAL_PMBX_MENTION_TITLE: 'Your mentions',
    SOCIAL_PMBX_REACTION_CONTENT_URL: 'Content',
    SOCIAL_PMBX_REACTION_DATE: 'Date',
    SOCIAL_PMBX_REACTION_LIKE: 'Posts you like',
    SOCIAL_PMBX_REACTION_ORIGIN: 'Where did you react to this post?',
    SOCIAL_PMBX_REACTION_TITLE: 'Posts you reacted to\t ',
    SOCIAL_PMBX_REACTION_USER_AGENT: 'User agent',
    SOCIAL_PMBX_SHARE_CONTENT_URL: 'Content',
    SOCIAL_PMBX_SHARE_DATE: 'Date',
    SOCIAL_PMBX_SHARE_GROUPS: 'Posts you shared with a group',
    SOCIAL_PMBX_SHARE_MESSAGE: 'What you wrote',
    SOCIAL_PMBX_SHARE_MESSENGER: 'Posts you shared as a private message',
    SOCIAL_PMBX_SHARE_ORIGIN: 'Where did you share this post?',
    SOCIAL_PMBX_SHARE_STARTPAGE: 'Posts you shared on XING',
    SOCIAL_PMBX_SHARE_TITLE: 'Posts you shared',
    SOCIAL_PMBX_SHARE_USER_AGENT: 'User agent',
    SOCIAL_PMBX_TITLE: 'Interactions',
    SOCIAL_REPLIES_LOAD_MORE: 'Show more replies',
    SOCIAL_REPLY_BUTTON: 'Reply',
    SOCIAL_REPLY_DISCARD_MESSAGE: 'Really discard this comment?',
    SOCIAL_REPLY_LOAD_MORE: 'Show 1 more reply',
    SOCIAL_REPLY_LOAD_MULTIPLE: 'Show more comments',
    SOCIAL_REPLY_POST_BUTTON: 'Reply',
    SOCIAL_SEND_MESSAGE: 'Write a message',
    SOCIAL_SHARE_COUNTER_LABEL: '{amount} shares',
    SOCIAL_SHARE_EXTERNAL_LINK_ERROR: "This link can't be shared.",
    SOCIAL_SHARERS_LIST_HEADLINE_MEMBERS: 'Members who shared this:',
    SOCIAL_SHARERS_LIST_ITEM_GO_TO_POST_LINK: 'View post',
    SOCIAL_SHARERS_LIST_POST_NOTIFICATION:
      "Some posts aren't visible here due to users' privacy settings.",
    SOCIAL_SHOW_MORE: 'Show more',
    SOCIAL_SOCIAL_PROOF_LABEL:
      '{counter, plural,\n    =1 {1 like:} \n    other {# likes:}\n}',
    SOCIAL_UPDATE_COMMENT_LABEL: 'Save',
    TOP_ARTICLE_PAID_COPY:
      'Highlight articles you want to appear at the top of your feed and swap them as needed.',
    TOP_ARTICLE_PAID_CTA: 'Discover all benefits',
    TOP_ARTICLE_PAID_FLAG: 'Employer Branding Profile',
    TOP_ARTICLE_PAID_HEADLINE: 'Prioritise content for visitors',
    TOP_BAR_BACK_BUTTON_ARIA_LABEL: 'Back',
    TOP_BAR_BACK_BUTTON_ARIA_LABEL_CUSTOM: 'Back to {section}',
    TOP_BAR_ME_MENU_DIMMER_ARIA_LABEL: 'Close menu',
    TOP_BAR_PROFILE_FILLING_INDICATOR_TITLE: 'Profile',
    XDS_FLAG_AMBASSADOR_DIVERSE: 'Ambassador',
    XDS_FLAG_AMBASSADOR_FEMALE: 'Ambassador',
    XDS_FLAG_AMBASSADOR_MALE: 'Ambassador',
    XDS_FLAG_AMBASSADOR_NEUTRAL: 'Ambassador',
    XDS_FLAG_BASIC_DIVERSE: 'Basic',
    XDS_FLAG_BASIC_FEMALE: 'Basic',
    XDS_FLAG_BASIC_MALE: 'Basic',
    XDS_FLAG_BASIC_NEUTRAL: 'Basic',
    XDS_FLAG_BETA_DIVERSE: 'Beta',
    XDS_FLAG_BETA_FEMALE: 'Beta',
    XDS_FLAG_BETA_MALE: 'Beta',
    XDS_FLAG_BETA_NEUTRAL: 'Beta',
    XDS_FLAG_INSIDER_DIVERSE: 'Insider',
    XDS_FLAG_INSIDER_FEMALE: 'Insider',
    XDS_FLAG_INSIDER_MALE: 'Insider',
    XDS_FLAG_INSIDER_NEUTRAL: 'Insider',
    XDS_FLAG_MODERATOR_DIVERSE: 'Moderator',
    XDS_FLAG_MODERATOR_FEMALE: 'Moderator',
    XDS_FLAG_MODERATOR_MALE: 'Moderator',
    XDS_FLAG_MODERATOR_NEUTRAL: 'Moderator',
    XDS_FLAG_NEW_DIVERSE: 'New',
    XDS_FLAG_NEW_FEMALE: 'New',
    XDS_FLAG_NEW_MALE: 'New',
    XDS_FLAG_NEW_NEUTRAL: 'New',
    XDS_FLAG_PREMIUM_DIVERSE: 'Premium',
    XDS_FLAG_PREMIUM_FEMALE: 'Premium',
    XDS_FLAG_PREMIUM_MALE: 'Premium',
    XDS_FLAG_PREMIUM_NEUTRAL: 'Premium',
    XDS_FLAG_PROBUSINESS_DIVERSE: 'ProBusiness',
    XDS_FLAG_PROBUSINESS_FEMALE: 'ProBusiness',
    XDS_FLAG_PROBUSINESS_MALE: 'ProBusiness',
    XDS_FLAG_PROBUSINESS_NEUTRAL: 'ProBusiness',
    XDS_FLAG_PROCOACH_DIVERSE: 'ProCoach',
    XDS_FLAG_PROCOACH_FEMALE: 'ProCoach',
    XDS_FLAG_PROCOACH_MALE: 'ProCoach',
    XDS_FLAG_PROCOACH_NEUTRAL: 'ProCoach',
    XDS_FLAG_PROJOBS_DIVERSE: 'ProJobs',
    XDS_FLAG_PROJOBS_FEMALE: 'ProJobs',
    XDS_FLAG_PROJOBS_MALE: 'ProJobs',
    XDS_FLAG_PROJOBS_NEUTRAL: 'ProJobs',
    XDS_FLAG_PROTRAINER_DIVERSE: 'ProTrainer',
    XDS_FLAG_PROTRAINER_FEMALE: 'ProTrainer',
    XDS_FLAG_PROTRAINER_MALE: 'ProTrainer',
    XDS_FLAG_PROTRAINER_NEUTRAL: 'ProTrainer',
    XING_FAQ_GUIDE_URL:
      'https://help.xing.com/hc/en-us/articles/33816993574801-Your-guide-to-networking?segment=b2c',
  },
};
